/*
================================================================ 
         Copyright (c) 2018-2021 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/
import { connect } from "react-redux";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Grid from "@mui/material/Grid";
import Button from "../../../component/button";
import BusApiCall from "../../../helper/axios";
import Loader from "../../../component/loader";
import actionTypes from "../../../store/actions";
import React, { Component, useRef } from "react";
import constants from "../../../helper/constants";
import { withTranslation } from "react-i18next";
import classes from "./component.module.css";
import Breadcrumb from "../../../component/breadcrumb";
import Icon from "@mui/material/Icon";

//dialog imports
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import ComponentTable from "./componentTable";
import ComponentDialog from "./componentDialog";
import jp from "jsonpath";

// import DefaultProductIcon from '../../../asset/images/defaultProductIcon.svg';
import { Box } from "@mui/material";
import ManageCustomersHierarchy from "../../sales/manageCustomers/manageCustomersHierarchy";

import Input from "../../../component/inputpm";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import {
  SearchIcon,
  ClearIcon,
  EditIconNew,
  MenuIcon,
  DetailView,
  ListView,
} from "../../../component/icons/icons";
import ClearIconMUI from "@mui/icons-material/Clear";
import CloseIcon from "@mui/icons-material/Close";
import Draggable from "react-draggable";
import { Paper } from "@mui/material";
import { Checkbox } from "@mui/material";
import { FormControlLabel } from "@mui/material";
import { DefaultProductIcon } from "../../../helper/setFallbackImages";
import TreeView from "../packagedSolution/treeView";
import Drawer from "@mui/material/Drawer";
import { ChevronLeft } from "@mui/icons-material";
import { Card } from "@mui/material";
import Switch from "@mui/material/Switch";
import { ButtonGroup } from "@mui/material";
// import { withStyles } from '@mui/styles';

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Chip from "@mui/material/Chip";
import { Select } from "@mui/material";
import { MenuItem } from "@mui/material";
import Pagination from "@mui/material/Pagination";
import { withNavigation } from "../../../helper/withNavigation";
import DraggableResizablePaper from "../../../component/resizablePaper/resizablePaper";
import Split from 'react-split';
import { formatNumber } from "../../../helper/numberFormatter";

// const styles = {
//     resizablePaper: {
//         resize: 'both',
//         overflow: 'auto',
//         minWidth: 640,
//         minHeight: 200,
//         maxWidth: '90vw',
//         maxHeight: '90vh',
//         width: '60vw',
//     },
// };
class ComponentProduct extends Component {
  // Declare property values that belongs to the component
  state = {
    status: "all_products",
    open: false,
    tabValue: 0,
    subTabValue: 0,
    subTabValue2: 0,
    loading: true,
    bread: [{ title: this.props.t("PRODUCTS"), url: "/products" }],

    // first tab to be displayed
    tabName: "",
    componentList: [],
    componentListProxy: [],
    activationResourceList: [],
    provisioningResourceList: [],
    preQualResourcesList: [],

    //define componenets
    associationType: [],
    hierarchy: [],

    //set componentType : by default setting the first tab value
    componentType: "",

    // Delete component keys
    showDelete: false,
    componentToDelete: "",
    indexToRemove: null,

    // Add component keys
    showAddComponent: false,

    objectToEdit: {},
    objectIndexToEdit: null,
    mode: "",
    bucketMismatched: false,
    duplicateExists: false,
    showImportDialog: false,
    existedProd: [],
    importedCompData: [],
    suspendResourceList: [],
    resumeResourceList: [],

    isBom: false,

    addComponentType: "",
    searchFilter: {
      name: "",
      featureCode: "",
      type: "",
      provider: "",
      status: "all_products",
    },
    allComponentsList: [],
    noComponentTypes: true,

    categoryList: [],
    productErrorMessage: "",

    channelList: [],
    specCategoryList: [],
    productSpecificationsCount: 0,
    customersList: [],
    proxyCustomersList: [],
    showCustomerDialog: false,
    productName: "",
    page: 1,
    perPage: 10,
    startRecord: 1,
    totalProductsCount: 0,

    sortBy: "productName",
    sortOrder: "ASC",

    viewMode: "default",
    // global search props
    globalSearchFilters: {
      name: "",
      code: "",
    },

    allGlobalProducts: [],
    globalSortBy: "productName",
    globalSortOrder: "ASC",

    globalPage: 1,
    globalPerPage: 10,
    globalStartRecord: 1,
    globalTotalProductsCount: 0,

    globalComponentType: "",
    globalActivationResourceList: [],
    globalProvisioningResourceList: [],
    globalSuspendResourceList: [],
    globalResumeResourceList: [],

    partnerProducts: false,
    selectedToExport: [],
    allCategoriesList: [],

    allOtherPricesList: [
      {
        name: "DEPOSIT_PRICE",
        value: "DEPOSIT",
        disabled: false,
      },
      {
        name: "CANCELLATION_PRICE",
        value: "CANCELLATION_PRICE",
        disabled: false,
      },
      {
        name: "SHIFT_PRICE",
        value: "SHIFT_PRICE",
        disabled: false,
      },
      {
        name: "SUSPENSION_PRICE",
        value: "SUSPENSION_PRICE",
        disabled: false,
      },
      {
        name: "REACTIVATION_PRICE",
        value: "REACTIVATION_PRICE",
        disabled: false,
      },
      {
        name: "USAGE_CHARGE",
        value: "USAGE_CHARGE",
        disabled: false,
      },
    ],
    priceOptions: [],
    partialLoading: false,
    selectAll: false,
    modules: {},
    leafNodes: [],
    isMobile: false,
    showCategory: false,
    showBucketsOnLeft: false,
    partnerList: [],
    productSpecsAppl: {}, // need to create product spec appl

    assocList: [],
    assocPerPage: 10,
    assocPage: 1,
    viewAssociatedOfferingsFor: null,
  };

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.updateIsMobile();
    window.addEventListener("resize", this.updateIsMobile);
    if (this.props.screen && this.props.screen === "createBom") {
      this.setState({
        isBom: true,
      });
    }

    var modules = JSON.parse(localStorage.getItem("modules"));
    this.setState({ modules: modules ? modules : {} });

    const storedViewMode = localStorage.getItem("productViewMode");
    const showBucketsOnLeft = localStorage.getItem("showBucketsOnLeft");
    this.setState({
      viewMode: storedViewMode || "default",
      showBucketsOnLeft: showBucketsOnLeft === "false" ? false : true,
    });

    //get partner list
    BusApiCall(
      "POST",
      `${constants.busInternalUrl}/passthru/GET_ASSOC_PARTNERS/endpoint`,
      {},
    )
      .then((res) => {
        let list = res.data.list;
        this.setState({ partnerList: list });
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({ loading: false });
      });

    //get the existing component products
    this.getComponentTypesAndDetails();
    this.getResources("ACTIVATION");
    this.getResources("PROVISIONING");
    this.getResources("SUBSCRIPTION_SUSPEND");
    this.getResources("SUBSCRIPTION_RESUME");
    this.getResources("QUALIFICATION");
    this.getCategories();
    this.getChannelsList();
    this.getSpecCategoryList();
    {
      this.props.menuPaths.includes("/specification") &&
        this.getSpecificationList();
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateIsMobile);
  }
  updateIsMobile = () => {
    const isMobile = window.matchMedia("(max-width: 960px)").matches;
    this.setState({ isMobile });
  };

  toggleShowCategory = () => {
    this.setState((prevState) => ({
      showCategory: !prevState.showCategory,
    }));
  };

  // disableOtherPriceOption = (list) => {
  //     if (list && list.length > 0) {
  //         var tempList = [];
  //         var allOtherPricesList = [...this.state.allOtherPricesList];
  //         for (var i = 0; i < allOtherPricesList.length; i++) {
  //             let items = jp.query(list, '$..[?(@.priceType=="' + allOtherPricesList[i].value + '")]');
  //             if (items.length > 0) {
  //                 if (items.length === 1) {
  //                     if (items[0].remove) {
  //                         tempList.push(allOtherPricesList[i]);
  //                     } else {
  //                         tempList.push({ ...allOtherPricesList[i], disabled: true });
  //                     }
  //                 } else {
  //                     tempList.push(allOtherPricesList[i]);
  //                 }
  //             } else {
  //                 tempList.push(allOtherPricesList[i]);
  //             }
  //         }
  //         this.setState({
  //             priceOptions: tempList
  //         })
  //     } else {
  //         var tempList = [...this.state.allOtherPricesList];
  //         this.setState({
  //             priceOptions: tempList
  //         })
  //     }
  // }

  disableOtherPriceOption = (list) => {
    if (list && list.length > 0) {
      var tempList = [];
      var allOtherPricesList = JSON.parse(
        JSON.stringify(this.state.allOtherPricesList),
      );

      for (var i = 0; i < allOtherPricesList.length; i++) {
        // Check if there are any items with the current priceType in the list
        let items = jp.query(
          list,
          '$..[?(@.priceType=="' + allOtherPricesList[i].value + '")]',
        );

        if (items.length > 0) {
          // If any of the items is not marked as removed, disable the option
          const anyNotRemoved = items.some((item) => !item.remove);

          if (anyNotRemoved) {
            tempList.push({ ...allOtherPricesList[i], disabled: true });
          } else {
            // If all items are removed, keep the option enabled
            tempList.push(allOtherPricesList[i]);
          }
        } else {
          // If no items with the priceType exist, keep the option enabled
          tempList.push(allOtherPricesList[i]);
        }
      }

      this.setState({
        priceOptions: tempList,
      });
    } else {
      var tempList = [...this.state.allOtherPricesList];
      this.setState({
        priceOptions: tempList,
      });
    }
  };

  //get the existing component products
  getProducts = () => {
    if (this.state.searchFilter.status == "all_products") {
      this.state.searchFilter.status = "";
    }
    if (this.state.viewMode === "search") {
      this.searchGlobalProducts();
    }
    this.setState({ loading: true });
    var customers = this.state.customersList.map((item) => {
      return item.partyId;
    });
    let pageOptions = {
      batchSize: this.state.perPage,
      startRecord: this.state.startRecord,
    };

    var url = `${constants.busV44UrlPublic}/products?productType=${this.state.componentType}&sortBy=${this.state.sortBy}&sortOrder=${this.state.sortOrder}${customers && customers.length > 0 ? "&customer=" + customers.join() : ""}${this.state.searchFilter.name ? "&name=" + this.state.searchFilter.name : ""}${this.state.searchFilter.featureCode ? "&code=" + this.state.searchFilter.featureCode : ""}${this.state.searchFilter.status ? "&status=" + this.state.searchFilter.status : ""}`;
    if (this.state.partnerProducts) {
      url = `${constants.busV44UrlPublic}/partners/products?productType=${this.state.componentType}&sortBy=${this.state.sortBy}&sortOrder=${this.state.sortOrder}${this.state.searchFilter.name ? "&name=" + this.state.searchFilter.name : ""}${this.state.searchFilter.selectedPartner ? "&provider=" + this.state.searchFilter.selectedPartner : ""}${this.state.searchFilter.featureCode ? "&code=" + this.state.searchFilter.featureCode : ""}${this.state.searchFilter.status ? "&status=" + this.state.searchFilter.status : ""}`;
    }

    BusApiCall("GET", url, {}, pageOptions)
      .then((res) => {
        // BusApiCall('GET', `${constants.busV4Url}/catalogs/products?componentType=${this.state.componentType}&mode=${this.state.isBom ? 'pmui' : 'component'}&customer=${customers.join()}`).then(res => {
        let data = res.data.map((value) => {
          value.open = false;
          return value;
        });
        if (data) {
          // if (data.length > 0) {
          //     data[0].price = JSON.parse(data[0].price).toFixed(2)
          // }
          this.setState(
            {
              open: false,
              componentList: data,
              totalProductsCount: +res.headers["x-total-count"],
            },
            () => {
              this.setState({
                loading: false,
              });
            },
          );
        }
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({ loading: false });
      });
  };

  submitCharacteristicsApplData = () => {
    this.setState({ showLoading: true });
    if (this.state.productSpecsAppl?.action === "DELETE") {
      BusApiCall(
        "DELETE",
        `${constants.busV44UrlPublic}/productSpecificationAppl/${this.state.productSpecsAppl.productId}`,
      )
        .then((res) => {
          this.setState({ showLoading: false, productSpecsAppl: {} });
          //this.props.setErrorMessage(this.props.t('SPECIFICATION_APPL_UNASSIGN_SUCCESSFULLY'), true);
        })
        .catch((err) => {
          this.setState({ showLoading: false, productSpecsAppl: {} });
          if (err.response && err.response.data && err.response.data.message) {
            this.props.setErrorMessage(err.response.data.message, false);
          } else {
            this.props.setErrorMessage(
              this.props.t("DEFAULT_ERROR_MESSAGE"),
              false,
            );
          }
          console.error("Error deleting product spec appl: ", err);
        });
    } else {
      console.log(
        "====submitCharacteristicsApplData=====this.state.productSpecsAppl=====",
        this.state.productSpecsAppl,
      );
      BusApiCall(
        "POST",
        `${constants.busV44UrlPublic}/productSpecificationAppl`,
        this.state.productSpecsAppl,
      )
        .then((res) => {
          this.setState({ showLoading: false, productSpecsAppl: {} });
          //this.props.setErrorMessage(this.props.t('SPECIFICATION_APPL_ASSIGN_SUCCESSFULLY'), true);
        })
        .catch((err) => {
          this.setState({ showLoading: false, productSpecsAppl: {} });
          if (err.response && err.response.data && err.response.data.message) {
            this.props.setErrorMessage(err.response.data.message, false);
          } else {
            this.props.setErrorMessage(
              this.props.t("DEFAULT_ERROR_MESSAGE"),
              false,
            );
          }
          console.error("Error creating product spec appl:", err);
        });
    }
  };

  expandProduct = (id) => {
    this.setState({
      loading: true,
    });
    var components = [...this.state.componentList];
    for (var i = 0; i < components.length; i++) {
      if (components[i].productId === id) {
        if (components[i].open) {
          components[i].open = !components[i].open;
          this.setState({
            componentList: components,
            loading: false,
          });
        } else {
          if (components[i].bom || components[i].variants) {
            components[i].open = !components[i].open;
            this.setState({
              componentList: components,
              loading: false,
            });
          } else {
            this.getFullProductDetails(id, i + 1);
          }
        }
      }
    }
  };

  getFullProductDetails = (id, index) => {
    var components = [...this.state.componentList];
    var index = components.findIndex((x) => x.productId === id);
    var url = `${constants.busV44UrlPublic}/product/${id}`;
    if (this.state.partnerProducts) {
      url = `${constants.busV44UrlPublic}/partners/${components[index].providerId}/products/${id}`;
    }
    BusApiCall("GET", url)
      .then((res) => {
        var tempProductData = res.data;
        var variants = [];
        components[index].bom = tempProductData.bom;
        if (tempProductData.variants && tempProductData.variants.length > 0) {
          for (var j = 0; j < tempProductData.variants.length; j++) {
            variants.push({
              name: tempProductData.variants[j].name,
              price: tempProductData.variants[j].price,
              productId: tempProductData.variants[j].productId,
              description: tempProductData.variants[j].description,
              featureCode: tempProductData.variants[j].productCode,
              deleteId: null,
              settlementContentId: null,
              componentsProvider: null,
              componentsProviderType: null,
              inventoryItemTypeId: null,
            });
          }
        }
        components[index].variants = variants;
        components[index].open = !components[index].open;
        this.setState({
          componentList: components,
          loading: false,
        });
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({
          loading: false,
        });
      });
  };

  // get the mapped component types
  getComponentTypesAndDetails = () => {
    this.setState({ loading: true });
    Promise.all([
      BusApiCall("GET", `${constants.busV4Url}/catalog/myComponentTypes`),
      BusApiCall("GET", `${constants.busV4Url}/catalog/allComponentTypes`),
    ])
      .then((res) => {
        let myComponentData = res[0].data;
        let allComponentData = res[1].data;
        let cData = JSON.parse(myComponentData.jsonResponse);
        var index = cData.findIndex((a) => a.id === "PROD_COMP_REF_PKG");
        var packageIndex = cData.findIndex((a) => a.id === "PROD_COMP_CTSOFT");
        if (
          packageIndex > -1 &&
          this.props.providerType !== "SALES_CHNL_PROVIDER"
        ) {
          cData.splice(packageIndex, 1);
        }
        if (index > -1) {
          cData.splice(index, 1);
        }
        let globalProdData = JSON.parse(allComponentData.jsonResponse);
        cData.push(...globalProdData.globalProducts);
        this.buildHierarchy(cData);
        this.sortSubCategories(this.state.hierarchy);
        this.setState({
          allCategoriesList: cData,
        });
        if (this.state.hierarchy && this.state.hierarchy.length > 0) {
          const leafSubcategory = this.getLeafSubcategory(
            this.state.hierarchy[0].subCategories,
          );
          if (leafSubcategory) {
            this.setState(
              {
                open: false,
                associationType: this.state.hierarchy,
                componentType: leafSubcategory.id,
                tabName: leafSubcategory.displayNamePlural
                  ? leafSubcategory.displayNamePlural
                  : leafSubcategory.name,
                noComponentTypes: false,
              },
              () => {
                if (this.state.viewMode === "default") {
                  this.getProducts();
                } else {
                  this.searchGlobalProducts();
                }
              },
            );
          } else {
            this.setState(
              {
                open: false,
                associationType: this.state.hierarchy,
                componentType: cData[0].id,
                tabName: cData[0].displayNamePlural
                  ? cData[0].displayNamePlural
                  : cData[0].name,
                noComponentTypes: false,
              },
              () => {
                if (this.state.viewMode === "default") {
                  this.getProducts();
                } else {
                  this.searchGlobalProducts();
                }
              },
            );
          }
        } else {
          this.props.setErrorMessage(
            this.props.t("NO_COMPONENT_TYPE_FOUND"),
            false,
          );
          this.setState({
            loading: false,
          });
        }
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({ loading: false });
      });
  };

  sortSubCategories = (dataArray) => {
    dataArray.forEach((obj) => {
      if (obj.subCategories && obj.subCategories.length > 0) {
        obj.subCategories.sort((a, b) => (a.name > b.name ? -1 : 1));
      }
    });
  };

  getLeafSubcategory = (subcategories) => {
    if (!subcategories || subcategories.length === 0) {
      return null;
    }

    const subcategory = subcategories[0]; // Assuming the leaf node is always the first element
    if (!subcategory.subCategories || subcategory.subCategories.length === 0) {
      return {
        id: subcategory.id,
        name: subcategory.displayNamePlural || subcategory.name,
      };
    }

    return this.getLeafSubcategory(subcategory.subCategories);
  };

  buildHierarchy = (cData2) => {
    for (let i = 0; i < cData2.length; i++) {
      const item = { ...cData2[i] };
      if (item.parentCategories) {
        delete item.parentCategories;
      }
      if (
        cData2[i].parentCategories &&
        cData2[i].parentCategories.length !== 0
      ) {
        const sub = { ...cData2[i].parentCategories[0], subCategories: [] };
        sub.subCategories.push(item);
        if (sub.parentCategories) {
          delete sub.parentCategories;
        }
        if (
          cData2[i].parentCategories[0].parentCategories &&
          cData2[i].parentCategories[0].parentCategories.length !== 0
        ) {
          const parent = {
            ...cData2[i].parentCategories[0].parentCategories[0],
            subCategories: [],
          };
          parent.subCategories.push(sub);
          if (parent.parentCategories) {
            delete parent.parentCategories;
          }
          this.createHierarchy(parent);
        } else {
          this.createHierarchy(sub);
        }
      } else {
        this.createHierarchy(item);
      }
    }
  };

  createHierarchy = (node) => {
    const { hierarchy } = this.state;
    // Find the parent node in the hierarchy
    const parentNodeIndex = hierarchy.findIndex((item) => item.id === node.id);

    if (parentNodeIndex !== -1) {
      // Parent node found
      const parentNode = hierarchy[parentNodeIndex];
      // Find the child node in the parent node's subCategories
      const childNodeIndex = parentNode.subCategories.findIndex(
        (item) => item.id === node.subCategories[0].id,
      );
      if (childNodeIndex !== -1) {
        // Child node found, push the new subCategory to its subCategories
        parentNode.subCategories[childNodeIndex].subCategories.push(
          ...node.subCategories[0].subCategories,
        );
      } else {
        // Child node not found, push the entire subCategories array to the parent node's subCategories
        parentNode.subCategories.push(...node.subCategories);
      }
    } else {
      // Parent node not found, push the entire node to the hierarchy
      hierarchy.push(node);
    }
    // Update the state with the new hierarchy
    this.setState({ hierarchy }, () => { });
  };

  //configuration methods
  getResources = (resourceType) => {
    this.setState({ loading: true });
    BusApiCall(
      "GET",
      `${constants.busV4Url}/resources?type=${resourceType}&associationType=${resourceType === "QUALIFICATION" ? "PROD_COMP_ALL" : this.state.componentType}`,
    )
      .then((res) => {
        let data = res.data;
        if (data && data.resourceList && data.resourceList.length > 0) {
          data.resourceList.sort((a, b) =>
            a.resourceName > b.resourceName
              ? 1
              : b.resourceName > a.resourceName
                ? -1
                : 0,
          );
          if (resourceType === "ACTIVATION") {
            let list = data.resourceList;
            list.forEach(function (item, i) {
              if (item.resourceId === "NOOP_ACT") {
                list.splice(i, 1);
                list.unshift(item);
              }
            });
            this.setState(
              {
                activationResourceList: list,
              },
              () => {
                // this.setState({ loading: false })
              },
            );
          } else if (resourceType === "PROVISIONING") {
            let list = data.resourceList;
            list.forEach(function (item, i) {
              if (item.resourceId === "NOOP_PROV") {
                list.splice(i, 1);
                list.unshift(item);
              }
            });
            this.setState(
              {
                provisioningResourceList: list,
              },
              () => {
                // this.setState({ loading: false })
              },
            );
          } else if (resourceType === "SUBSCRIPTION_SUSPEND") {
            let list = data.resourceList;
            list.forEach(function (item, i) {
              if (item.resourceId === "NOOP_SUB_SUSPEND") {
                list.splice(i, 1);
                list.unshift(item);
              }
            });
            this.setState(
              {
                suspendResourceList: list,
              },
              () => {
                // this.setState({ loading: false })
              },
            );
          } else if (resourceType === "SUBSCRIPTION_RESUME") {
            let list = data.resourceList;
            list.forEach(function (item, i) {
              if (item.resourceId === "NOOP_SUB_RESUME") {
                list.splice(i, 1);
                list.unshift(item);
              }
            });
            this.setState(
              {
                resumeResourceList: list,
              },
              () => {
                // this.setState({ loading: false })
              },
            );
          } else if (resourceType === "QUALIFICATION") {
            let list = data.resourceList;
            list.forEach(function (item, i) {
              if (item.resourceId === "NOOP_SUB_RESUME") {
                list.splice(i, 1);
                list.unshift(item);
              }
            });
            this.setState(
              {
                preQualResourcesList: list,
              },
              () => {
                // this.setState({ loading: false })
              },
            );
          }
        }
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({ loading: false });
      });
  };

  getCategories = () => {
    BusApiCall(
      "GET",
      `${constants.busV4Url}/providers/${this.props.providerId}/menus`,
    )
      .then((res) => {
        this.setState({
          categoryList: res.data.menuCategories,
        });
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({ loading: false });
      });
  };

  //for the component tabs
  handleChange = (event, newValue) => {
    this.clearFilters();
    const leafSubcategory = this.getLeafSubcategory(
      this.state.associationType[newValue].subCategories,
    );
    let tabName, associationTypeValue;
    if (leafSubcategory) {
      tabName = leafSubcategory.displayNamePlural
        ? leafSubcategory.displayNamePlural
        : leafSubcategory.name;
      associationTypeValue = leafSubcategory.id;
    } else {
      tabName = this.state.associationType[newValue].displayNamePlural
        ? this.state.associationType[newValue].displayNamePlural
        : this.state.associationType[newValue].name;
      associationTypeValue = this.state.associationType[newValue].id;
    }

    //set the name of the table
    this.setState(
      {
        tabName: tabName,
        tabValue: newValue,
        subTabValue: 0,
        subTabValue2: 0,
        componentType: associationTypeValue,
        page: 1,
        perPage: 10,
        startRecord: 1,
        selectAll: false,
      },
      () => {
        //call the get the existing component products API, as tab is changed
        // this.getProducts();
        this.getResources("ACTIVATION");
        this.getResources("PROVISIONING");
        this.getResources("SUBSCRIPTION_SUSPEND");
        this.getResources("SUBSCRIPTION_RESUME");
      },
    );
  };

  handleSubChange = (event, newValue) => {
    this.clearFilters();
    const leafSubcategory = this.getLeafSubcategory(
      this.state.associationType[this.state.tabValue].subCategories[newValue]
        .subCategories,
    );
    let tabName, associationTypeValue;
    if (leafSubcategory) {
      tabName = leafSubcategory.displayNamePlural
        ? leafSubcategory.displayNamePlural
        : leafSubcategory.name;
      associationTypeValue = leafSubcategory.id;
    } else {
      tabName = this.state.associationType[this.state.tabValue].subCategories[
        newValue
      ].displayNamePlural
        ? this.state.associationType[this.state.tabValue].subCategories[
          newValue
        ].displayNamePlural
        : this.state.associationType[this.state.tabValue].subCategories[
          newValue
        ].name;
      associationTypeValue =
        this.state.associationType[this.state.tabValue].subCategories[newValue]
          .id;
    }
    this.setState(
      {
        subTabValue: newValue,
        subTabValue2: 0,
        tabName: tabName,
        componentType: associationTypeValue,
        page: 1,
        perPage: 10,
        startRecord: 1,
        selectAll: false,
      },
      () => {
        this.getResources("ACTIVATION");
        this.getResources("PROVISIONING");
        this.getResources("SUBSCRIPTION_SUSPEND");
        this.getResources("SUBSCRIPTION_RESUME");
      },
    );
  };

  handleSub2Change = (event, newValue) => {
    this.clearFilters();
    const leafSubcategory =
      this.state.associationType[this.state.tabValue].subCategories[
        this.state.subTabValue
      ].subCategories[newValue];
    let tabName, associationTypeValue;
    if (leafSubcategory) {
      tabName = leafSubcategory.displayNamePlural
        ? leafSubcategory.displayNamePlural
        : leafSubcategory.name;
      associationTypeValue = leafSubcategory.id;
    } else {
      //if no 3rd level subcategory
    }

    this.setState(
      {
        subTabValue2: newValue,
        tabName: tabName,
        componentType: associationTypeValue,
        page: 1,
        perPage: 10,
        startRecord: 1,
        selectAll: false,
      },
      () => {
        this.getResources("ACTIVATION");
        this.getResources("PROVISIONING");
        this.getResources("SUBSCRIPTION_SUSPEND");
        this.getResources("SUBSCRIPTION_RESUME");
      },
    );
  };

  // Remove copmponent start
  openRemoveComponent = (id, index) => {
    this.setState({
      componentToDelete: id,
      indexToRemove: index,
      showDelete: true,
    });
  };

  closeDeleteCoponentDialog = (val) => {
    if (val) {
      let components = [...this.state.componentList];
      this.setState({ partialLoading: true });
      BusApiCall(
        "DELETE",
        `${constants.busV4Url}/components/products/${this.state.componentToDelete}`,
      )
        .then((res) => {
          if (res.data.productId) {
            components.splice(this.state.indexToRemove, 1);
            this.getProducts();
            this.setState(
              {
                // componentList: components,
                // indexToRemove: null,
                // showDelete: false
              },
              () => {
                this.props.setErrorMessage(
                  this.props.t("PRODUCT_DELETED_SUCCESSFULLY"),
                  true,
                );
                this.setState({ partialLoading: false });
              },
            );
          }
        })
        .catch((err) => {
          this.setState({ partialLoading: false });
          if (err.response && err.response.data && err.response.data.message) {
            this.props.setErrorMessage(err.response.data.message, false);
          } else {
            this.props.setErrorMessage(
              this.props.t("DEFAULT_ERROR_MESSAGE"),
              false,
            );
          }
        });
      this.setState({
        componentToDelete: "",
        indexToRemove: null,
        showDelete: false,
      });
    } else {
      this.setState({
        componentToDelete: "",
        indexToRemove: null,
        showDelete: false,
      });
    }
  };

  // Remove copmponent end

  // Add component start

  openComponentDialog = (type) => {
    this.setState({
      mode: "add",
      showAddComponent: true,
      addComponentType: type,
    });
  };

  closeComponentDialog = (val) => {
    this.setState({
      productErrorMessage: "",
    });
    if (val) {
      // product specification appl data set
      if (val.assignedSpecs && Object.keys(val.assignedSpecs).length > 0) {
        this.setState({
          productSpecsAppl: val.assignedSpecs,
        });
        delete val.assignedSpecs;
      }
      if (val.unassignSpec && Object.keys(val.unassignSpec).length > 0) {
        this.setState({
          productSpecsAppl: val.unassignSpec,
        });
        delete val.unassignSpec;
      }

      if (val.bom && val.bom.length > 0) {
        val.bom.forEach(function iter(a) {
          delete a.productType;
          Array.isArray(a.bom) && a.bom.forEach(iter);
        });
      }
      if (val.children) {
        for (var i = 0; i < val.children.length; i++) {
          delete val.children[i].expandKitComponents;
        }
      }
      val.assembly = this.state.addComponentType === "assembly" ? true : false;
      val.name = val.name.trim();
      val.description = val.description.trim();
      for (var i = 0; i < val.customAttributes.length; i++) {
        if (val.customAttributes[i].valueType === "boolean") {
          val.customAttributes[i].attrValue =
            "" + val.customAttributes[i].attrValue;
        }
      }
      this.setState({ loading: true });
      console.log('check final product data', val);
      // return;
      if (this.state.mode === "add" || this.state.mode === "kit") {
        BusApiCall("POST", `${constants.busV4Url}/components/products`, val)
          .then((res) => {
            if (res.data.productId) {
              console.log(
                "=========this.state.productSpecsAppl=====",
                this.state.productSpecsAppl,
              );
              if (
                this.state.productSpecsAppl &&
                Object.keys(this.state.productSpecsAppl).length > 0
              ) {
                // we assign/unassign product spec appl from editSpecCharacteristicsAppl.js
                this.setState((prevState) => ({
                  productSpecsAppl: {
                    ...prevState.productSpecsAppl,
                    productId: res.data.productId,
                  },
                }));
                this.submitCharacteristicsApplData();
              }
              this.getProducts();

              this.setState({
                showAddComponent: false,
                addComponentType: "",
                productErrorMessage: "",
              });
              this.props.setErrorMessage(
                this.props.t("PRODUCT_CREATED_SUCCESSFULLY"),
                true,
              );
            } else {
              // this.props.setErrorMessage(res.data.message, false)
              this.setState({
                // showAddComponent: false,
                // addComponentType: '',
                loading: false,
                productErrorMessage: res.data.message,
              });
            }
          })
          .catch((err) => {
            this.getProducts();
            this.setState({
              loading: false,
              // showAddComponent: false,
              // addComponentType: '',
              productErrorMessage:
                err.response && err.response.data && err.response.data.message
                  ? err.response.data.message
                  : this.props.t("DEFAULT_ERROR_MESSAGE"),
            });
            // if (err.response && err.response.data && err.response.data.message) {
            //     this.props.setErrorMessage(err.response.data.message, false)
            // } else {
            //     this.props.setErrorMessage(this.props.t('DEFAULT_ERROR_MESSAGE'), false);
            // }
          });
      } else {
        delete val.inventoryItemAndDetail;
        if (val.bom) {
          for (var j = 0; j < val.bom.length; j++) {
            if (val.bom[j].inventoryItemAndDetail) {
              delete val.bom[j].inventoryItemAndDetail;
            }
            if (val.bom[j].bom) {
              for (var k = 0; k < val.bom[j].bom.length; k++) {
                delete val.bom[j].bom[k].inventoryItemAndDetail;
              }
            }
          }
        }
        delete val.history;
        BusApiCall(
          "PATCH",
          `${constants.busV4Url}/components/products/${this.state.objectToEdit.id}`,
          val,
        )
          .then((res) => {
            if (
              this.state.productSpecsAppl &&
              Object.keys(this.state.productSpecsAppl).length > 0
            ) {
              // we assign/unassign product spec appl from editSpecCharacteristicsAppl.js
              //this.submitCharacteristicsApplData();
            }
            if (this.state.viewMode === "default") {
              this.getProducts();
            }
            if (this.state.viewMode === "search") {
              this.searchGlobalProducts();
            }
            this.setState({
              showAddComponent: false,
              addComponentType: "",
              objectToEdit: {},
              objectIndexToEdit: null,
              mode: "",
              globalProvisioningResourceList: [],
              globalActivationResourceList: [],
              globalSuspendResourceList: [],
              globalResumeResourceList: [],
              globalComponentType: "",
            });
            this.props.setErrorMessage(
              this.props.t("PRODUCT_UPDATED_SUCCESSFULLY"),
              true,
            );
          })
          .catch((err) => {
            if (this.state.viewMode === "default") {
              this.getProducts();
            }
            if (this.state.viewMode === "search") {
              this.searchGlobalProducts();
            }
            this.setState({
              loading: false,
              productErrorMessage:
                err.response && err.response.data && err.response.data.message
                  ? err.response.data.message
                  : this.props.t("DEFAULT_ERROR_MESSAGE"),
              // showAddComponent: false,
              // objectToEdit: {},
              // objectIndexToEdit: null,
              // mode: '',
              // addComponentType: ''
            });
            // if (err.response && err.response.data && err.response.data.message) {
            //     this.props.setErrorMessage(err.response.data.message, false)
            // } else {
            //     this.props.setErrorMessage(this.props.t('DEFAULT_ERROR_MESSAGE'), false)
            // }
          });
      }
    } else {
      console.log('discard changes and close')
      this.setState({
        showAddComponent: false,
        mode: "",
        objectToEdit: {},
        objectIndexToEdit: null,
        addComponentType: "",
        productErrorMessage: "",
        globalProvisioningResourceList: [],
        globalActivationResourceList: [],
        globalSuspendResourceList: [],
        globalResumeResourceList: [],
        globalComponentType: "",
      });
    }
  };

  resetErrorMessage = () => {
    this.setState({
      productErrorMessage: "",
    });
  };

  // Add component end

  // edit component

  openEditComponent = (row, index) => {
    this.setState(
      {
        partialLoading: true,
      },
      () => {
        var url = `${constants.busV44UrlPublic}/product/${row.productId}`;
        if (this.state.partnerProducts) {
          url = `${constants.busV44UrlPublic}/partners/${row.providerId}/products/${row.productId}`;
        }
        BusApiCall("GET", url)
          .then((res) => {
            var tempProductData = res.data;
            if (
              tempProductData.variants &&
              tempProductData.variants.length > 0
            ) {
              for (var v = 0; v < tempProductData.variants.length; v++) {
                tempProductData.variants[v].price = Number(
                  tempProductData.variants[v].price,
                ).toFixed(2);
                if (
                  tempProductData.variants[v].otherPrices &&
                  tempProductData.variants[v].otherPrices.length > 0
                ) {
                  for (
                    var vo = 0;
                    vo < tempProductData.variants[v].otherPrices.length;
                    vo++
                  ) {
                    tempProductData.variants[v].otherPrices[vo].price = Number(
                      tempProductData.variants[v].otherPrices[vo].price,
                    ).toFixed(2);
                  }
                }
              }
            }
            if (
              tempProductData.otherPrices &&
              tempProductData.otherPrices.length > 0
            ) {
              for (var i = 0; i < tempProductData.otherPrices.length; i++) {
                tempProductData.otherPrices[i].id = "100" + i;
                tempProductData.otherPrices[i].price = Number(
                  tempProductData.otherPrices[i].price,
                ).toFixed(2);
                if (
                  tempProductData.otherPrices[i].priceType === "USAGE_CHARGE"
                ) {
                  if (tempProductData.otherPrices[i].priceTenureUOM) {
                  } else {
                    tempProductData.otherPrices[i].priceTenureUOM = "TF_hr";
                    tempProductData.otherPrices[i].priceTenure = 1;
                  }
                }
              }
            }
            if (res.data.price.priceType === "RC") {
              tempProductData.price.priceTenureUOM = res.data.price.termUomId
                ? res.data.price.termUomId
                : "TF_mon";
              tempProductData.price.priceTenure = res.data.price.termPeriod
                ? res.data.price.termPeriod
                : "1";
              //code for quarterly term period
              // if (res.data.price.termUomId) {
              //     tempProductData.price.priceTenureUOM = res.data.price.termUomId === 'TF_mon' ? res.data.price.termPeriod === '3' ? 'TF_qtr' : 'TF_mon' : res.data.price.termUomId
              //     tempProductData.price.priceTenure = res.data.price.termPeriod
              // } else {
              //     tempProductData.price.priceTenureUOM = 'TF_mon'
              //     tempProductData.price.priceTenure = '1'
              // }
              // tempProductData.price.priceType= res.data.price.priceType
            } else {
              tempProductData.price.priceTenureUOM =
                res.data.price.priceTenureUOM;
              tempProductData.price.priceTenure = res.data.price.priceTenure;
              // tempProductData.price.priceType= res.data.price.priceType
            }
            var finalProductData = {
              status: tempProductData.status,
              history: tempProductData.history,
              featureCode: tempProductData.productCode,
              sellable: tempProductData.sellable,
              description: tempProductData.description,
              internalName: tempProductData.name,
              price: tempProductData.price.priceAmount.toFixed(2),
              otherPrices: tempProductData.otherPrices,
              assembly: tempProductData.assembly,
              id: tempProductData.productId,
              componentName: tempProductData.category
                ? tempProductData.category.name
                : "",
              physical: tempProductData.physical,
              inventoried: tempProductData.inventoried,
              isCustomerViewable: tempProductData.customerViewable,
              componentType: tempProductData.category
                ? tempProductData.category.id
                : "",
              priceTenureUOM: tempProductData.price.priceTenureUOM,
              priceTenure: tempProductData.price.priceTenure,
              priceType:
                tempProductData.price.priceType === "NTC"
                  ? "NTC"
                  : tempProductData.price.priceType === "NR"
                    ? "NRC"
                    : "RC",
              name: tempProductData.name,
              customer: tempProductData.customer
                ? tempProductData.customer
                : [],
              bom: tempProductData.bom,
              provisioning: tempProductData.provisioning
                ? tempProductData.provisioning
                : {},
              activation: tempProductData.activation
                ? tempProductData.activation
                : {},
              suspendResource: tempProductData.suspendResource
                ? tempProductData.suspendResource
                : {},
              resumeResource: tempProductData.resumeResource
                ? tempProductData.resumeResource
                : {},
              customAttributes: [],
              inventoryItemType:
                tempProductData.inventoryItemType === ""
                  ? "NON_SERIALIZED_ITEM"
                  : tempProductData.inventoryItemType === "NON_SERIAL_INV_ITEM"
                    ? "NON_SERIALIZED_ITEM"
                    : "SERIALIZED_ITEM",
              preQuals: [],
              variants: [],
              enrichmentConfig: {},
              localisedName: [],
              localisedDesc: [],

              resourceId: "",
              rawMaterial: tempProductData.rawMaterial,
              inventoryDetails: null,
              language: "",

              // fromProviderType: "",
              // fromProviderId: '',
              // fromProviderName: '',
              // isStandAlone: '',
              // children: [],
            };

            if (
              tempProductData.qualifications &&
              tempProductData.qualifications.length > 0
            ) {
              for (var i = 0; i < tempProductData.qualifications.length; i++) {
                var qual = tempProductData.qualifications[i];
                if (typeof qual.extraFields === "string") {
                  qual.extraFields = {};
                }
                finalProductData.preQuals.push(qual);
              }
            }

            if (
              tempProductData.i18nName &&
              tempProductData.i18nName.length > 0
            ) {
              finalProductData.localisedName = tempProductData.i18nName;
            }
            if (
              tempProductData.i18nDesc &&
              tempProductData.i18nDesc.length > 0
            ) {
              finalProductData.localisedDesc = tempProductData.i18nDesc;
            }

            if (tempProductData.sellable) {
              finalProductData.basicDetail = {
                categoryId: tempProductData.category
                  ? tempProductData.category.id
                  : "",
                productOverview: "",
                productTechSpecs: "",
                productWhatsIncluded: "",
                productMainImage: "",
                productMainImageSource: "",
                productName: tempProductData.name,
                productDescription: tempProductData.description,
                startingPrice: tempProductData.price.priceAmount,

                productAdditionalImage1: "",
                productAdditionalImage2: "",
                productAdditionalImage3: "",
                productAdditionalImage4: "",
                productAdditionalImage1Src: "",
                productAdditionalImage2Src: "",
                productAdditionalImage3Src: "",
                productAdditionalImage4Src: "",
                terms: [],
                overrideStartingPrice: false,
              };
              for (var a = 0; a < tempProductData.attachments.length; a++) {
                if (tempProductData.attachments[a].type === "IMAGE") {
                  finalProductData.basicDetail.productMainImage =
                    tempProductData.attachments[a].url;
                }
                if (tempProductData.attachments[a].type === "WHATSINCLUDED") {
                  finalProductData.basicDetail.productWhatsIncluded =
                    tempProductData.attachments[a].richText;
                }
                if (tempProductData.attachments[a].type === "SPECIFICATION") {
                  finalProductData.basicDetail.productTechSpecs =
                    tempProductData.attachments[a].richText;
                }
                if (tempProductData.attachments[a].type === "OVERVIEW") {
                  finalProductData.basicDetail.productOverview =
                    tempProductData.attachments[a].richText;
                }
              }
              finalProductData.releaseDate = tempProductData.releaseDate;
              finalProductData.expiryDate = tempProductData.expiryDate;
            }

            // set variants
            if (
              tempProductData.variants &&
              tempProductData.variants.length > 0
            ) {
              for (var i = 0; i < tempProductData.variants.length; i++) {
                var vr = {
                  name: tempProductData.variants[i].name,
                  price: tempProductData.variants[i].price,
                  productId: tempProductData.variants[i].productId,
                  description: tempProductData.variants[i].description,
                  featureCode: tempProductData.variants[i].productCode,
                  deleteId: null,
                  settlementContentId: null,
                  componentsProvider: null,
                  componentsProviderType: null,
                  inventoryItemTypeId: null,
                  otherPrices: [],
                  priceOptions: JSON.parse(
                    JSON.stringify(this.state.allOtherPricesList),
                  ),
                };
                if (
                  tempProductData.variants[i].otherPrices &&
                  tempProductData.variants[i].otherPrices.length > 0
                ) {
                  for (
                    var j = 0;
                    j < tempProductData.variants[i].otherPrices.length;
                    j++
                  ) {
                    var priceOptionIndex = vr.priceOptions.findIndex(
                      (x) =>
                        x.value ===
                        tempProductData.variants[i].otherPrices[j].priceType,
                    );
                    if (priceOptionIndex > -1) {
                      vr.priceOptions[priceOptionIndex].disabled = true;
                    }
                    tempProductData.variants[i].otherPrices[j].id = "100" + i;
                    if (
                      tempProductData.variants[i].otherPrices[j].priceType ===
                      "USAGE_CHARGE"
                    ) {
                      if (
                        tempProductData.variants[i].otherPrices[j]
                          .priceTenureUOM
                      ) {
                      } else {
                        tempProductData.variants[i].otherPrices[
                          j
                        ].priceTenureUOM = "TF_hr";
                        tempProductData.variants[i].otherPrices[j].priceTenure =
                          1;
                      }
                    }
                    vr.otherPrices.push(
                      tempProductData.variants[i].otherPrices[j],
                    );
                  }
                }
                finalProductData.variants.push(vr);
              }
            }

            // set custom attributes
            var originalBucket = jp.query(
              this.state.allCategoriesList,
              '$[?(@.id=="' + this.state.componentType + '")]',
            );
            var originalBucketAttributes =
              originalBucket && originalBucket.length > 0
                ? originalBucket[0].customAttributes
                : [];
            if (Object.keys(tempProductData.attributes).length > 0) {
              Object.keys(tempProductData.attributes).map((key) => {
                if (
                  originalBucketAttributes &&
                  originalBucketAttributes.length > 0
                ) {
                  var tempIndex = originalBucketAttributes.findIndex(
                    (x) => x.attrName === key,
                  );
                  if (tempIndex > -1) {
                    var tempAttribute = {
                      create: false,
                      delete: false,
                      update: false,
                      productId: tempProductData.productId,
                      valueType: originalBucketAttributes[tempIndex].valueType,
                      attrType: "CUSTOM_ATTRIBUTE",
                      attrName: key,
                      attrValue: tempProductData.attributes[key],
                      required: originalBucketAttributes[tempIndex].required,
                      options: originalBucketAttributes[tempIndex].options,
                    };
                    finalProductData.customAttributes.push(tempAttribute);
                  }
                }
              });
            }
            // set enrichment configurations
            var tempEnrichmentConfig = {
              visible: [],
              removeable: [],
              purchaseable: [],
              rePurchaseable: [],
            };
            if (
              tempProductData.visibiltyOptions &&
              tempProductData.visibiltyOptions.length > 0
            ) {
              for (var i = 0; i < this.state.channelList.length; i++) {
                var tempIndex = tempProductData.visibiltyOptions.findIndex(
                  (x) => x.channelName === this.state.channelList[i].value,
                );
                if (tempIndex > -1) {
                  tempEnrichmentConfig.visible.push(
                    this.state.channelList[i].id +
                    ":" +
                    tempProductData.visibiltyOptions[tempIndex].visibility
                      .visible,
                  );
                  tempEnrichmentConfig.removeable.push(
                    this.state.channelList[i].id +
                    ":" +
                    tempProductData.visibiltyOptions[tempIndex].visibility
                      .removable,
                  );
                  tempEnrichmentConfig.purchaseable.push(
                    this.state.channelList[i].id +
                    ":" +
                    tempProductData.visibiltyOptions[tempIndex].visibility
                      .purchasable,
                  );
                  tempEnrichmentConfig.rePurchaseable.push(
                    this.state.channelList[i].id +
                    ":" +
                    tempProductData.visibiltyOptions[tempIndex].visibility
                      .rePurchasable,
                  );
                }
              }
            }
            finalProductData.enrichmentConfig = {
              visible: tempEnrichmentConfig.visible.join(),
              removeable: tempEnrichmentConfig.removeable.join(),
              purchaseable: tempEnrichmentConfig.purchaseable.join(),
              rePurchaseable: tempEnrichmentConfig.rePurchaseable.join(),
            };
            if (
              finalProductData.provisioning &&
              finalProductData.provisioning.extraFields
            ) {
              var length = Object.keys(
                finalProductData.provisioning.extraFields,
              ).length;
              if (length > 0) {
                for (var key in finalProductData.provisioning.extraFields) {
                  var lowKey = key.toLowerCase();
                  if (lowKey.includes("username")) {
                    var order = { [key]: null };
                    var newObject = Object.assign(
                      order,
                      finalProductData.provisioning.extraFields,
                    );
                    finalProductData.provisioning.extraFields = newObject;
                  }
                }
              }
            }
            if (
              finalProductData.activation &&
              finalProductData.activation.extraFields
            ) {
              var length = Object.keys(
                finalProductData.activation.extraFields,
              ).length;
              if (length > 0) {
                for (var key in finalProductData.activation.extraFields) {
                  var lowKey = key.toLowerCase();
                  if (lowKey.includes("username")) {
                    var order = { [key]: null };
                    var newObject = Object.assign(
                      order,
                      finalProductData.activation.extraFields,
                    );
                    finalProductData.activation.extraFields = newObject;
                  }
                }
              }
            }
            if (
              finalProductData.resumeResource &&
              finalProductData.resumeResource.extraFields
            ) {
              var length = Object.keys(
                finalProductData.resumeResource.extraFields,
              ).length;
              if (length > 0) {
                for (var key in finalProductData.resumeResource.extraFields) {
                  var lowKey = key.toLowerCase();
                  if (lowKey.includes("username")) {
                    var order = { [key]: null };
                    var newObject = Object.assign(
                      order,
                      finalProductData.resumeResource.extraFields,
                    );
                    finalProductData.resumeResource.extraFields = newObject;
                  }
                }
              }
            }
            if (
              finalProductData.suspendResource &&
              finalProductData.suspendResource.extraFields
            ) {
              var length = Object.keys(
                finalProductData.suspendResource.extraFields,
              ).length;
              if (length > 0) {
                for (var key in finalProductData.suspendResource.extraFields) {
                  var lowKey = key.toLowerCase();
                  if (lowKey.includes("username")) {
                    var order = { [key]: null };
                    var newObject = Object.assign(
                      order,
                      finalProductData.suspendResource.extraFields,
                    );
                    finalProductData.suspendResource.extraFields = newObject;
                  }
                }
              }
            }
            this.setState({
              addComponentType: tempProductData.assembly
                ? "assembly"
                : "component",
              mode: "edit",
              objectIndexToEdit: index,
              objectToEdit: finalProductData,
              showAddComponent: true,
              partialLoading: false,
            });
          })
          .catch((err) => {
            if (
              err.response &&
              err.response.data &&
              err.response.data.message
            ) {
              this.props.setErrorMessage(err.response.data.message, false);
            } else {
              this.props.setErrorMessage(
                this.props.t("DEFAULT_ERROR_MESSAGE"),
                false,
              );
            }
            this.setState({ partialLoading: false });
          });
      },
    );
    // this.setState({
    //     addComponentType: row.assembly ? 'assembly' : 'component'
    // })
    // let rowData = row;
    // if (rowData.children && rowData.children.length > 0) {
    //     for (var i = 0; i < rowData.children.length; i++) {
    //         rowData.children[i].expandKitComponents = false;
    //     }
    // }
    // this.setState({
    //     mode: 'edit',
    //     objectIndexToEdit: index,
    //     objectToEdit: row,
    //     showAddComponent: true
    // })
  };

  openGlobalEditComponent = (row, index) => {
    this.setState(
      {
        globalComponentType: row.productType.id,
        partialLoading: true,
      },
      () => {
        var url = `${constants.busV44UrlPublic}/product/${row.productId}`;
        if (this.state.partnerProducts) {
          url = `${constants.busV44UrlPublic}/partners/${row.providerId}/products/${row.productId}`;
        }
        Promise.all([
          BusApiCall(
            "GET",
            `${constants.busV4Url}/resources?type=PROVISIONING&associationType=${this.state.globalComponentType}`,
          ),
          BusApiCall(
            "GET",
            `${constants.busV4Url}/resources?type=ACTIVATION&associationType=${this.state.globalComponentType}`,
          ),
          BusApiCall(
            "GET",
            `${constants.busV4Url}/resources?type=SUBSCRIPTION_SUSPEND&associationType=${this.state.globalComponentType}`,
          ),
          BusApiCall(
            "GET",
            `${constants.busV4Url}/resources?type=SUBSCRIPTION_RESUME&associationType=${this.state.globalComponentType}`,
          ),
          BusApiCall("GET", url),
        ])
          .then((res) => {
            // Set provisioning resources
            var tempProv = res[0].data.resourceList;
            var provResources = [];
            if (tempProv && tempProv.length > 0) {
              var sortedProv = tempProv.sort((a, b) =>
                a.resourceName > b.resourceName
                  ? 1
                  : b.resourceName > a.resourceName
                    ? -1
                    : 0,
              );
              sortedProv.forEach(function (item, i) {
                if (item.resourceId === "NOOP_ACT") {
                  sortedProv.splice(i, 1);
                  sortedProv.unshift(item);
                }
              });
              provResources = sortedProv;
            }

            // Set activation resources
            var tempAct = res[1].data.resourceList;
            var actResources = [];
            if (tempAct && tempAct.length > 0) {
              var sortedAct = tempAct.sort((a, b) =>
                a.resourceName > b.resourceName
                  ? 1
                  : b.resourceName > a.resourceName
                    ? -1
                    : 0,
              );
              sortedAct.forEach(function (item, i) {
                if (item.resourceId === "NOOP_ACT") {
                  sortedAct.splice(i, 1);
                  sortedAct.unshift(item);
                }
              });
              actResources = sortedAct;
            }

            // Set suspend resources
            var tempSuspend = res[2].data.resourceList;
            var suspendResources = [];
            if (tempSuspend && tempSuspend.length > 0) {
              var sortedSuspend = tempSuspend.sort((a, b) =>
                a.resourceName > b.resourceName
                  ? 1
                  : b.resourceName > a.resourceName
                    ? -1
                    : 0,
              );
              sortedSuspend.forEach(function (item, i) {
                if (item.resourceId === "NOOP_ACT") {
                  sortedSuspend.splice(i, 1);
                  sortedSuspend.unshift(item);
                }
              });
              suspendResources = sortedSuspend;
            }

            // Set resume resources
            var tempResume = res[3].data.resourceList;
            var resumeResources = [];
            if (tempResume && tempResume.length > 0) {
              var sortedResume = tempResume.sort((a, b) =>
                a.resourceName > b.resourceName
                  ? 1
                  : b.resourceName > a.resourceName
                    ? -1
                    : 0,
              );
              sortedResume.forEach(function (item, i) {
                if (item.resourceId === "NOOP_ACT") {
                  sortedResume.splice(i, 1);
                  sortedResume.unshift(item);
                }
              });
              resumeResources = sortedResume;
            }

            // Set Product Data
            var tempProductData = res[4].data;
            if (res[4].data.price.priceType === "RC") {
              tempProductData.price.priceTenureUOM =
                res[4].data.price.termUomId === "TF_mon"
                  ? res[4].data.price.termPeriod === "3"
                    ? "TF_qtr"
                    : "TF_mon"
                  : res[4].data.price.termUomId;
              tempProductData.price.priceTenure = res[4].data.price.termPeriod;
              // tempProductData.price.priceType= res.data.price.priceType
            } else {
              tempProductData.price.priceTenureUOM =
                res[4].data.price.priceTenureUOM;
              tempProductData.price.priceTenure = res[4].data.price.priceTenure;
              // tempProductData.price.priceType= res.data.price.priceType
            }
            if (
              tempProductData.variants &&
              tempProductData.variants.length > 0
            ) {
              for (var v = 0; v < tempProductData.variants.length; v++) {
                tempProductData.variants[v].price = Number(
                  tempProductData.variants[v].price,
                ).toFixed(2);
                if (
                  tempProductData.variants[v].otherPrices &&
                  tempProductData.variants[v].otherPrices.length > 0
                ) {
                  for (
                    var vo = 0;
                    vo < tempProductData.variants[v].otherPrices.length;
                    vo++
                  ) {
                    tempProductData.variants[v].otherPrices[vo].price = Number(
                      tempProductData.variants[v].otherPrices[vo].price,
                    ).toFixed(2);
                  }
                }
              }
            }
            if (
              tempProductData.otherPrices &&
              tempProductData.otherPrices.length > 0
            ) {
              for (var i = 0; i < tempProductData.otherPrices.length; i++) {
                tempProductData.otherPrices[i].id = "100" + i;
                tempProductData.otherPrices[i].price = Number(
                  tempProductData.otherPrices[i].price,
                ).toFixed(2);
                if (
                  tempProductData.otherPrices[i].priceType === "USAGE_CHARGE"
                ) {
                  if (tempProductData.otherPrices[i].priceTenureUOM) {
                  } else {
                    tempProductData.otherPrices[i].priceTenureUOM = "TF_hr";
                    tempProductData.otherPrices[i].priceTenure = 1;
                  }
                }
              }
            }
            var finalProductData = {
              featureCode: tempProductData.productCode,
              sellable: tempProductData.sellable,
              description: tempProductData.description,
              internalName: tempProductData.name,
              price: tempProductData.price.priceAmount.toFixed(2),
              otherPrices: tempProductData.otherPrices,
              assembly: tempProductData.assembly,
              id: tempProductData.productId,
              componentName: tempProductData.category
                ? tempProductData.category.name
                : "",
              physical: tempProductData.physical,
              inventoried: tempProductData.inventoried,
              isCustomerViewable: tempProductData.customerViewable,
              componentType: tempProductData.category
                ? tempProductData.category.id
                : "",
              priceTenureUOM: tempProductData.price.priceTenureUOM,
              priceTenure: tempProductData.price.priceTenure,
              priceType:
                tempProductData.price.priceType === "NTC"
                  ? "NTC"
                  : tempProductData.price.priceType === "NR"
                    ? "NRC"
                    : "RC",
              name: tempProductData.name,
              customer: tempProductData.customer
                ? tempProductData.customer
                : [],
              bom: tempProductData.bom,
              provisioning: tempProductData.provisioning
                ? tempProductData.provisioning
                : {},
              activation: tempProductData.activation
                ? tempProductData.activation
                : {},
              suspendResource: tempProductData.suspendResource
                ? tempProductData.suspendResource
                : {},
              resumeResource: tempProductData.resumeResource
                ? tempProductData.resumeResource
                : {},
              customAttributes: [],
              inventoryItemType:
                tempProductData.inventoryItemType === ""
                  ? "NON_SERIALIZED_ITEM"
                  : tempProductData.inventoryItemType === "NON_SERIAL_INV_ITEM"
                    ? "NON_SERIALIZED_ITEM"
                    : "SERIALIZED_ITEM",
              preQuals: [],
              variants: [],
              enrichmentConfig: {},
              localisedName: [],
              localisedDesc: [],

              resourceId: "",
              rawMaterial: tempProductData.rawMaterial,
              inventoryDetails: null,
              language: "",
              status: tempProductData.status,

              // fromProviderType: "",
              // fromProviderId: '',
              // fromProviderName: '',
              // isStandAlone: '',
              // children: [],
            };

            if (
              tempProductData.qualifications &&
              tempProductData.qualifications.length > 0
            ) {
              for (var i = 0; i < tempProductData.qualifications.length; i++) {
                var qual = tempProductData.qualifications[i];
                if (typeof qual.extraFields === "string") {
                  qual.extraFields = {};
                }
                finalProductData.preQuals.push(qual);
              }
            }

            if (
              tempProductData.i18nName &&
              tempProductData.i18nName.length > 0
            ) {
              finalProductData.localisedName = tempProductData.i18nName;
            }
            if (
              tempProductData.i18nDesc &&
              tempProductData.i18nDesc.length > 0
            ) {
              finalProductData.localisedDesc = tempProductData.i18nDesc;
            }

            if (tempProductData.sellable) {
              finalProductData.basicDetail = {
                categoryId: tempProductData.category
                  ? tempProductData.category.id
                  : "",
                productOverview: "",
                productTechSpecs: "",
                productWhatsIncluded: "",
                productMainImage: "",
                productMainImageSource: "",
                productName: tempProductData.name,
                productDescription: tempProductData.description,
                startingPrice: tempProductData.price.priceAmount,

                productAdditionalImage1: "",
                productAdditionalImage2: "",
                productAdditionalImage3: "",
                productAdditionalImage4: "",
                productAdditionalImage1Src: "",
                productAdditionalImage2Src: "",
                productAdditionalImage3Src: "",
                productAdditionalImage4Src: "",
                terms: [],
                overrideStartingPrice: false,
              };
              for (var a = 0; a < tempProductData.attachments.length; a++) {
                if (tempProductData.attachments[a].type === "IMAGE") {
                  finalProductData.basicDetail.productMainImage =
                    tempProductData.attachments[a].url;
                }
                if (tempProductData.attachments[a].type === "WHATSINCLUDED") {
                  finalProductData.basicDetail.productWhatsIncluded =
                    tempProductData.attachments[a].richText;
                }
                if (tempProductData.attachments[a].type === "SPECIFICATION") {
                  finalProductData.basicDetail.productTechSpecs =
                    tempProductData.attachments[a].richText;
                }
                if (tempProductData.attachments[a].type === "OVERVIEW") {
                  finalProductData.basicDetail.productOverview =
                    tempProductData.attachments[a].richText;
                }
              }
              finalProductData.releaseDate = tempProductData.releaseDate;
              finalProductData.expiryDate = tempProductData.expiryDate;
            }

            // set variants
            if (
              tempProductData.variants &&
              tempProductData.variants.length > 0
            ) {
              for (var i = 0; i < tempProductData.variants.length; i++) {
                var vr = {
                  name: tempProductData.variants[i].name,
                  price: tempProductData.variants[i].price,
                  productId: tempProductData.variants[i].productId,
                  description: tempProductData.variants[i].description,
                  featureCode: tempProductData.variants[i].productCode,
                  deleteId: null,
                  settlementContentId: null,
                  componentsProvider: null,
                  componentsProviderType: null,
                  inventoryItemTypeId: null,
                  otherPrices: [],
                  priceOptions: JSON.parse(
                    JSON.stringify(this.state.allOtherPricesList),
                  ),
                };
                if (
                  tempProductData.variants[i].otherPrices &&
                  tempProductData.variants[i].otherPrices.length > 0
                ) {
                  for (
                    var j = 0;
                    j < tempProductData.variants[i].otherPrices.length;
                    j++
                  ) {
                    var priceOptionIndex = vr.priceOptions.findIndex(
                      (x) =>
                        x.value ===
                        tempProductData.variants[i].otherPrices[j].priceType,
                    );
                    if (priceOptionIndex > -1) {
                      vr.priceOptions[priceOptionIndex].disabled = true;
                    }
                    tempProductData.variants[i].otherPrices[j].id = "100" + i;
                    if (
                      tempProductData.variants[i].otherPrices[j].priceType ===
                      "USAGE_CHARGE"
                    ) {
                      if (
                        tempProductData.variants[i].otherPrices[j]
                          .priceTenureUOM
                      ) {
                      } else {
                        tempProductData.variants[i].otherPrices[
                          j
                        ].priceTenureUOM = "TF_hr";
                        tempProductData.variants[i].otherPrices[j].priceTenure =
                          1;
                      }
                    }
                    vr.otherPrices.push(
                      tempProductData.variants[i].otherPrices[j],
                    );
                  }
                }
                finalProductData.variants.push(vr);
              }
            }

            // set custom attributes
            var originalBucket = jp.query(
              this.state.allCategoriesList,
              '$[?(@.id=="' + this.state.globalComponentType + '")]',
            );
            var originalBucketAttributes =
              originalBucket && originalBucket.length > 0
                ? originalBucket[0].customAttributes
                : [];
            if (Object.keys(tempProductData.attributes).length > 0) {
              Object.keys(tempProductData.attributes).map((key) => {
                if (
                  originalBucketAttributes &&
                  originalBucketAttributes.length > 0
                ) {
                  var tempIndex = originalBucketAttributes.findIndex(
                    (x) => x.attrName === key,
                  );
                  if (tempIndex > -1) {
                    var tempAttribute = {
                      create: false,
                      delete: false,
                      update: false,
                      productId: tempProductData.productId,
                      valueType: originalBucketAttributes[tempIndex].valueType,
                      attrType: "CUSTOM_ATTRIBUTE",
                      attrName: key,
                      attrValue: tempProductData.attributes[key],
                      required: originalBucketAttributes[tempIndex].required,
                      options: originalBucketAttributes[tempIndex].options,
                    };
                    finalProductData.customAttributes.push(tempAttribute);
                  }
                }
              });
            }
            // set enrichment configurations
            var tempEnrichmentConfig = {
              visible: [],
              removeable: [],
              purchaseable: [],
              rePurchaseable: [],
            };

            if (
              tempProductData.visibiltyOptions &&
              tempProductData.visibiltyOptions.length > 0
            ) {
              for (var i = 0; i < this.state.channelList.length; i++) {
                var tempIndex = tempProductData.visibiltyOptions.findIndex(
                  (x) => x.channelName === this.state.channelList[i].value,
                );
                if (tempIndex > -1) {
                  tempEnrichmentConfig.visible.push(
                    this.state.channelList[i].id +
                    ":" +
                    tempProductData.visibiltyOptions[tempIndex].visibility
                      .visible,
                  );
                  tempEnrichmentConfig.removeable.push(
                    this.state.channelList[i].id +
                    ":" +
                    tempProductData.visibiltyOptions[tempIndex].visibility
                      .removable,
                  );
                  tempEnrichmentConfig.purchaseable.push(
                    this.state.channelList[i].id +
                    ":" +
                    tempProductData.visibiltyOptions[tempIndex].visibility
                      .purchasable,
                  );
                  tempEnrichmentConfig.rePurchaseable.push(
                    this.state.channelList[i].id +
                    ":" +
                    tempProductData.visibiltyOptions[tempIndex].visibility
                      .rePurchasable,
                  );
                }
              }
            }

            finalProductData.enrichmentConfig = {
              visible: tempEnrichmentConfig.visible.join(),
              removeable: tempEnrichmentConfig.removeable.join(),
              purchaseable: tempEnrichmentConfig.purchaseable.join(),
              rePurchaseable: tempEnrichmentConfig.rePurchaseable.join(),
            };
            if (
              finalProductData.provisioning &&
              finalProductData.provisioning.extraFields
            ) {
              var length = Object.keys(
                finalProductData.provisioning.extraFields,
              ).length;
              if (length > 0) {
                for (var key in finalProductData.provisioning.extraFields) {
                  var lowKey = key.toLowerCase();
                  if (lowKey.includes("username")) {
                    var order = { [key]: null };
                    var newObject = Object.assign(
                      order,
                      finalProductData.provisioning.extraFields,
                    );
                    finalProductData.provisioning.extraFields = newObject;
                  }
                }
              }
            }
            if (
              finalProductData.activation &&
              finalProductData.activation.extraFields
            ) {
              var length = Object.keys(
                finalProductData.activation.extraFields,
              ).length;
              if (length > 0) {
                for (var key in finalProductData.activation.extraFields) {
                  var lowKey = key.toLowerCase();
                  if (lowKey.includes("username")) {
                    var order = { [key]: null };
                    var newObject = Object.assign(
                      order,
                      finalProductData.activation.extraFields,
                    );
                    finalProductData.activation.extraFields = newObject;
                  }
                }
              }
            }
            if (
              finalProductData.resumeResource &&
              finalProductData.resumeResource.extraFields
            ) {
              var length = Object.keys(
                finalProductData.resumeResource.extraFields,
              ).length;
              if (length > 0) {
                for (var key in finalProductData.resumeResource.extraFields) {
                  var lowKey = key.toLowerCase();
                  if (lowKey.includes("username")) {
                    var order = { [key]: null };
                    var newObject = Object.assign(
                      order,
                      finalProductData.resumeResource.extraFields,
                    );
                    finalProductData.resumeResource.extraFields = newObject;
                  }
                }
              }
            }
            if (
              finalProductData.suspendResource &&
              finalProductData.suspendResource.extraFields
            ) {
              var length = Object.keys(
                finalProductData.suspendResource.extraFields,
              ).length;
              if (length > 0) {
                for (var key in finalProductData.suspendResource.extraFields) {
                  var lowKey = key.toLowerCase();
                  if (lowKey.includes("username")) {
                    var order = { [key]: null };
                    var newObject = Object.assign(
                      order,
                      finalProductData.suspendResource.extraFields,
                    );
                    finalProductData.suspendResource.extraFields = newObject;
                  }
                }
              }
            }
            this.setState({
              globalProvisioningResourceList: provResources,
              globalActivationResourceList: actResources,
              globalSuspendResourceList: suspendResources,
              globalResumeResourceList: resumeResources,
              addComponentType: tempProductData.assembly
                ? "assembly"
                : "component",
              mode: "edit",
              objectIndexToEdit: index,
              objectToEdit: finalProductData,
              showAddComponent: true,
              partialLoading: false,
            });
          })
          .catch((err) => {
            if (
              err.response &&
              err.response.data &&
              err.response.data.message
            ) {
              this.props.setErrorMessage(err.response.data.message, false);
            } else {
              this.props.setErrorMessage(
                this.props.t("DEFAULT_ERROR_MESSAGE"),
                false,
              );
            }
            this.setState({ partialLoading: false });
          });
      },
    );

    // provisioningResources={this.state.provisioningResourceList}
    //                     activationResources={this.state.activationResourceList}
    //                     suspendResources={this.state.suspendResourceList}
    //                     resumeResources={this.state.resumeResourceList}
    // channelList={this.state.channelList}
  };

  exportAllComponent = () => {
    return;
    let exportedData = {};
    let compList = [];
    if (this.state.componentListProxy.length > 0) {
      for (let item of this.state.componentListProxy) {
        var customAttributes = item.customAttributes
          ? item.customAttributes
          : [];
        customAttributes.forEach((c) => {
          delete c.create;
          delete c.delete;
          delete c.update;
          delete c.productId;
          delete c.valueType;
        });
        let tempComp = {
          name: item.name.trim(),
          featureCode: item.featureCode,
          description: item.description.trim(),
          price: item.price,
          priceType: item.priceType,
          variants: item.variants ? item.variants : [],
          provisioning: item.provisioning,
          activation: item.activation,
          suspendResource: item.suspendResource,
          resumeResource: item.resumeResource,
          assembly: item.assembly,
          //isStandAlone: item.isStandAlone,
          physical: item.physical,
          rawMaterial: item.rawMaterial,
          inventoried: item.inventoried,
          sellable: item.sellable,
          inventoryItemType: item.inventoryItemType,
          basicDetail: item.basicDetail,
          orderApproval: item.orderApproval,
          customAttributes: customAttributes,
          enrichmentConfig: item.enrichmentConfig,
          originalProviderId: this.props.providerId,
        };
        if (item.assembly) {
          tempComp.children = item.children ? item.children : [];
          tempComp.routing = item.routing
            ? item.routing
            : {
              name: "",
              description: "",
              routingTasks: [],
            };
        }
        if (item.bom && item.bom.length > 0) {
          tempComp.bom = item.bom;
        }
        if (item.priceType === "NTC" || item.priceType === "RC") {
          tempComp.priceTenure = item.priceTenure;
          tempComp.priceTenureUOM = item.priceTenureUOM;
        }
        compList.push(tempComp);
      }
      exportedData.compList = compList;
      exportedData.bucketType = this.state.componentType;
      exportedData.bucketName = this.state.tabName;
      let josnFile =
        "text/json;charset=utf-8," +
        encodeURIComponent(JSON.stringify(exportedData));
      var link = document.createElement("a");
      link.href = "data:" + josnFile;
      link.download = this.state.tabName + ".json";
      link.dispatchEvent(new MouseEvent("click"));
    }
  };

  verifyUploadedFile = (file) => {
    this.setState({ loading: true });
    let fileReader = new FileReader();
    if (file.length > 1) {
      file = file.splice(file.length - 1, 1);
    }
    fileReader.readAsText(file[0]);
    fileReader.onload = (event) => {
      try {
        const parsedData = JSON.parse(event.target.result);
        this.createImportedComponent(parsedData);
      } catch (error) {
        this.props.setErrorMessage(this.props.t("INVALID_JSON_FILE"), false);
      } finally {
        this.setState({ loading: false });
      }
      // if (/^[\],:{}\s]*$/.test(event.target.result.replace(/\\["\\\/bfnrtu]/g, '@').
      //     replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, ']').replace(/(?:^|:|,)(?:\s*\[)+/g, ''))) {
      //     // this.importAllComponent(JSON.parse(event.target.result))
      //     this.createImportedComponent(JSON.parse(event.target.result));
      // } else {
      //     this.props.setErrorMessage(this.props.t('INVALID_JSON_FILE'), false)
      // }
    };
  };

  importAllComponent = (importedData) => {
    // Set date in state
    this.setState({
      importedCompData: importedData.compList,
    });
    if (importedData.bucketType !== this.state.componentType) {
      this.setState({ loading: false });
      this.state.bucketMismatched = true;
      this.state.duplicateExists = false;
      this.openImportDialog();
    } else {
      var existedProd = [];
      // var nameArr = this.state.componentList.map(function (item) { return item.internalName });
      // for (let item of importedData.compList) {
      //     if (nameArr.indexOf(item.name) !== -1) {
      //         existedProd.push(item.name);
      //     }
      // }

      if (existedProd.length > 0) {
        this.setState({
          existedProd: existedProd,
        });
        // show warning
        this.setState({ loading: false });
        this.state.bucketMismatched = false;
        this.state.duplicateExists = true;
        this.openImportDialog();
      } else {
        // Call Api to import
        this.createImportedComponent();
      }
    }
  };

  closeImportDialog = (val) => {
    if (val) {
      this.createImportedComponent();
    }
    this.setState({
      showImportDialog: false,
      mode: "",
    });
  };

  closeImportVarifyDialog = (val) => {
    if (val) {
      // skip already existing
      var addCompList = this.state.importedCompData;
      // remove duplicats
      addCompList = addCompList.filter(
        (item) => !this.state.existedProd.includes(item.name),
      );
      if (addCompList.length > 0) {
        this.setState(
          {
            importedCompData: addCompList,
          },
          () => {
            this.createImportedComponent();
          },
        );
      }
    }

    this.setState({
      showImportDialog: false,
      mode: "",
    });
  };

  openImportDialog = () => {
    this.setState({
      showImportDialog: true,
    });
  };

  createImportedComponent = (data) => {
    this.setState({ loading: true });
    var componentList = [...data];
    // set the component type
    // for (let item of this.state.importedCompData) {
    //     item.componentType = this.state.componentType
    //     componentList.push(item);
    // }
    var jsonData = {
      components: componentList,
    };
    BusApiCall(
      "POST",
      `${constants.busInternalUrl}/passthru/IMPORT_COMPONENTS/endpoint`,
      jsonData,
    )
      .then((res) => {
        this.getProducts();
        this.setState({
          showAddComponent: false,
          addComponentType: "",
        });
        if (res.data.code === "500" || res.data.code === "400") {
          this.props.setErrorMessage(res.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("PRODUCT_IMPORT_START"),
            true,
          );
        }
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({ loading: false });
      });
  };

  // edit componenet end

  changePage = (e, page) => {
    this.setState(
      {
        page: page,
        startRecord: this.state.perPage * (page - 1) + 1,
        selectAll: false,
      },
      () => {
        this.getProducts();
      },
    );
  };

  globalChangePage = (e, page) => {
    this.setState(
      {
        globalPage: page,
        globalStartRecord: this.state.globalPerPage * (page - 1) + 1,
        selectAll: false,
      },
      () => {
        this.searchGlobalProducts();
      },
    );
  };

  changeRowsPerPage = (event) => {
    this.setState(
      {
        perPage: event.target.value,
        page: 1,
        startRecord: 1,
        selectAll: false,
      },
      () => {
        this.getProducts();
      },
    );
  };

  globalChangeRowsPerPage = (event) => {
    this.setState(
      {
        globalPerPage: event.target.value,
        globalPage: 1,
        globalStartRecord: 1,
        selectAll: false,
      },
      () => {
        this.searchGlobalProducts();
      },
    );
  };

  paginate = () => {
    return this.state.componentListProxy.slice(
      (this.state.page - 1) * this.state.perPage,
      this.state.page * this.state.perPage,
    );
  };

  // updateExportSelection = (id) => {
  //     var selectedToExport = [...this.state.selectedToExport];
  //     var index = selectedToExport.findIndex(x => x === id);
  //     if (index > -1) {
  //         selectedToExport.splice(index, 1);
  //     } else {
  //         selectedToExport.push(id);
  //     }
  //     this.setState({
  //         selectedToExport: selectedToExport
  //     })
  // }

  updateExportSelection = (id, productCode) => {
    var selectedItems = [...this.state.selectedToExport];
    const existingIndex = selectedItems.findIndex((item) => item.id === id);
    if (existingIndex > -1) {
      selectedItems.splice(existingIndex, 1);
    } else {
      selectedItems.push({ id, productCode });
    }
    this.setState({
      selectedToExport: selectedItems,
      selectAll: false,
    });
  };

  selectAllVisibleProducts = (value) => {
    if (value) {
      if (this.state.viewMode === "search") {
        var list = [...this.state.allGlobalProducts];
      } else {
        var list = [...this.state.componentList];
      }
      var selectedItems = [...this.state.selectedToExport];
      for (var i = 0; i < list.length; i++) {
        const existingIndex = selectedItems.findIndex(
          (item) => item.id === list[i].productId,
        );
        if (existingIndex > -1) {
          // selectedItems.splice(existingIndex, 1);
        } else {
          selectedItems.push({
            id: list[i].productId,
            productCode: list[i].productCode,
          });
        }
      }
      this.setState({
        selectedToExport: selectedItems,
        selectAll: true,
      });
    } else {
      if (this.state.viewMode === "search") {
        var list = [...this.state.allGlobalProducts];
      } else {
        var list = [...this.state.componentList];
      }
      var selectedItems = [...this.state.selectedToExport];
      for (var i = 0; i < list.length; i++) {
        const existingIndex = selectedItems.findIndex(
          (item) => item.id === list[i].productId,
        );
        if (existingIndex > -1) {
          selectedItems.splice(existingIndex, 1);
        } else {
          // selectedItems.push({ id: list[i].productId, productCode: list[i].productCode });
        }
      }
      this.setState({
        selectedToExport: selectedItems,
        selectAll: false,
      });
    }
  };

  exportSelectedItems = () => {
    const selectedProductIds = this.state.selectedToExport.map(
      (item) => item.id,
    );
    if (selectedProductIds && selectedProductIds.length > 0) {
      this.setState({ loading: true });
      var payload = {
        exportBy: "id",
        selectedProducts: selectedProductIds,
      };
      BusApiCall(
        "POST",
        `${constants.busV44UrlPublic}/export/products`,
        payload,
      )
        .then((res) => {
          // var base64Data = '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';
          // var base64ToJson = Buffer.from(base64Data, "base64").toString();
          // var formattedJson = JSON.parse(base64ToJson);
          var formattedJson = res.data;

          let compList = [];
          for (let item of formattedJson) {
            var customAttributes = item.customAttributes
              ? item.customAttributes
              : [];
            customAttributes.forEach((c) => {
              delete c.create;
              delete c.delete;
              delete c.update;
              delete c.productId;
              delete c.valueType;
            });
            let tempComp = {
              name: item.name.trim(),
              featureCode: item.featureCode,
              description: item.description.trim(),
              price: item.price,
              priceType: item.priceType,
              variants: item.variants ? item.variants : [],
              provisioning: item.provisioning,
              activation: item.activation,
              suspendResource: item.suspendResource,
              resumeResource: item.resumeResource,
              assembly: item.assembly,
              //isStandAlone: item.isStandAlone,
              physical: item.physical,
              rawMaterial: item.rawMaterial,
              inventoried: item.inventoried,
              sellable: item.sellable,
              inventoryItemType: item.inventoryItemType,
              customAttributes: customAttributes,
              enrichmentConfig: item.enrichmentConfig,
              basicDetail: item.basicDetail,
              orderApproval: item.orderApproval,
              originalProviderId: this.props.providerId,
              componentType: item.componentType,
              localisedName: item.localisedName,
              localisedDesc: item.localisedDesc,
              otherPrices: item.otherPrices,
              customer: item.customer ? item.customer : [],
            };
            if (item.sellable) {
              tempComp.expiryDate = item.expiryDate ? item.expiryDate : "";
              tempComp.releaseDate = item.releaseDate ? item.releaseDate : "";
            }
            if (item.assembly) {
              tempComp.children = item.children ? item.children : [];
              tempComp.routing = item.routing
                ? item.routing
                : {
                  name: "",
                  description: "",
                  routingTasks: [],
                };
            }
            if (item.bom && item.bom.length > 0) {
              tempComp.bom = item.bom;
            }
            if (item.priceType === "NTC" || item.priceType === "RC") {
              tempComp.priceTenure = item.priceTenure;
              tempComp.priceTenureUOM = item.priceTenureUOM;
            }
            compList.push(tempComp);
          }

          let josnFile =
            "text/json;charset=utf-8," +
            encodeURIComponent(JSON.stringify(compList));
          var link = document.createElement("a");
          link.href = "data:" + josnFile;
          link.download = "products.json";
          link.dispatchEvent(new MouseEvent("click"));
          this.setState({
            loading: false,
            selectedToExport: [],
            selectAll: false,
          });
        })
        .catch((err) => {
          if (err.response && err.response.data && err.response.data.message) {
            this.props.setErrorMessage(err.response.data.message, false);
          } else {
            this.props.setErrorMessage(
              this.props.t("DEFAULT_ERROR_MESSAGE"),
              false,
            );
          }
          this.setState({ loading: false });
        });
    } else {
      this.props.setErrorMessage(
        this.props.t("NO_ITEMS_SELECTED_TO_EXPORT"),
        false,
      );
    }
  };

  resetExportSelection = () => {
    var componentListProxy = [...this.state.componentListProxy];
    for (var i = 0; i < componentListProxy.length; i++) {
      componentListProxy[i].export = false;
      if (i + 1 === componentListProxy.length) {
        this.setState({
          componentListProxy,
        });
      }
    }
  };

  updateFilter = (e) => {
    let filter = { ...this.state.searchFilter };
    filter[e.target.name] = e.target.value;
    this.setState({
      searchFilter: filter,
    });
  };

  filterComponents = () => {
    this.setState(
      {
        page: 1,
        startRecord: 1,
      },
      () => {
        this.getProducts();
      },
    );
  };

  globalFilterComponents = () => {
    this.setState(
      {
        globalPage: 1,
        globalStartRecord: 1,
      },
      () => {
        this.searchGlobalProducts();
      },
    );
  };

  clearFilters = () => {
    this.setState(
      {
        searchFilter: {
          name: "",
          featureCode: "",
          status: "",
        },
        page: 1,
        startRecord: 1,
      },
      () => {
        this.filterComponents();
      },
    );
  };

  onSearchKeyDown = (e) => {
    if (e.key === "Enter") {
      if (this.state.viewMode === "default") {
        this.filterComponents();
      } else {
        this.searchGlobalProducts();
      }
    }
  };

  getChannelsList = () => {
    BusApiCall("GET", `${constants.busV44Url}/getChannels`)
      .then((res) => {
        this.setState({
          channelList: res.data.channelList,
        });
      })
      .catch((err) => { });
  };

  getSpecCategoryList = () => {
    const formData = { type: "PRODUCT_SPEC_CAT" };
    const prioritizedItemId = "PSC_PROD";
    BusApiCall(
      "POST",
      `${constants.busInternalUrl}/passthru/GET_PROD_SPEC_CHAR_CAT/endpoint`,
      formData,
    )
      .then((res) => {
        if (res.data?.categories) {
          const sortedCategoryList = [
            ...res.data.categories.filter(
              (item) => item.id === prioritizedItemId,
            ),
            ...res.data.categories
              .filter((item) => item.id !== prioritizedItemId)
              .sort((a, b) => a.name.localeCompare(b.name)),
          ];
          this.setState({ specCategoryList: sortedCategoryList });
        }
      })
      .catch((err) => {
        console.error("Error fetching Product Spec Category:", err);
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
      });
  };

  getSpecificationList = () => {
    this.setState({ showLoading: true });
    let pageOptions = {
      batchSize: 20,
      startRecord: 1,
    };
    var url = `${constants.busV44UrlPublic}/productSpecifications?sortBy=name&sortOrder=ASC`;
    BusApiCall("GET", url, "", pageOptions)
      .then((res) => {
        this.setState({ showLoading: false });
        if (res.data.length > 0) {
          this.setState({
            productSpecificationsCount: res.data.length,
          });
        } else {
          this.setState({
            productSpecificationsCount: 0,
          });
        }
      })
      .catch((err) => {
        console.error("Error fetching Product Specifications:", err);
        this.setState({ showLoading: false });
      });
  };

  changeCustomer = () => {
    this.setState(
      {
        proxyCustomersList: JSON.parse(
          JSON.stringify(this.state.customersList),
        ),
      },
      () => {
        this.setState({
          showCustomerDialog: true,
        });
      },
    );
  };

  clearCustomerSelection = () => {
    this.setState(
      {
        proxyCustomersList: [],
        customersList: [],
      },
      () => {
        if (this.state.viewMode === "default") {
          this.getProducts();
        }
        if (this.state.viewMode === "search") {
          this.searchGlobalProducts();
        }
      },
    );
  };

  selectCustomers = (customer) => {
    var tempData = [...this.state.proxyCustomersList];
    var tempIndex = tempData.findIndex((x) => x.partyId === customer.partyId);
    if (tempIndex > -1) {
      tempData.splice(tempIndex, 1);
    } else {
      tempData.push(customer);
    }
    this.setState({
      proxyCustomersList: tempData,
    });
  };

  closeChangeCustomer = (val) => {
    if (val) {
      this.setState(
        {
          customersList: JSON.parse(
            JSON.stringify(this.state.proxyCustomersList),
          ),
          showCustomerDialog: false,
        },
        () => {
          if (this.state.viewMode === "default") {
            this.getProducts();
          }
          if (this.state.viewMode === "search") {
            this.searchGlobalProducts();
          }
        },
      );
    } else {
      this.setState({
        showCustomerDialog: false,
        proxyCustomersList: [],
      });
    }
  };

  globalSearchChange = (e) => {
    var filters = { ...this.state.globalSearchFilters };
    filters[e.target.name] = e.target.value;
    this.setState({
      globalSearchFilters: filters,
    });
  };
  globalSearchClear = () => {
    this.setState(
      {
        globalSearchFilters: {
          name: "",
          code: "",
        },
        globalPage: 1,
        globalStartRecord: 1,
        globalTotalProductsCount: 0,
      },
      () => {
        this.searchGlobalProducts();
      },
    );
  };

  getCustomerName = (id) => {
    var index = this.state.customersList.findIndex((x) => x.partyId === id);
    if (index > -1) {
      return this.state.customersList[index].accountName + "\n";
    } else {
      return;
    }
  };

  handleKeyDown = (event) => {
    if (event.key === "Enter") {
      this.globalSearch();
    }
  };
  deleteDialog = (props) => {
    const nodeRef = useRef(null);
    return (
      <Draggable
        nodeRef={nodeRef}
        bounds={"parent"}
        defaultClassName="customReactDraggableComponent"
        handle="#delete-dialog"
        cancel={'[class*="MuiDialogContent-root"]'}
      >
        <Paper ref={nodeRef} {...props} />
      </Draggable>
    );
  };

  importDialog = (props) => {
    const nodeRef = useRef(null);
    return (
      <Draggable
        nodeRef={nodeRef}
        bounds={"parent"}
        defaultClassName="customReactDraggableComponent"
        handle="#import-dialog"
        cancel={'[class*="MuiDialogContent-root"]'}
      >
        <Paper ref={nodeRef} {...props} />
      </Draggable>
    );
  };

  selectCustomerDialog = (props) => {
    const nodeRef = useRef(null);
    return (
      <Draggable
        nodeRef={nodeRef}
        bounds={"parent"}
        defaultClassName="customReactDraggableComponent"
        handle="#select-customer-dialog"
        cancel={'[class*="MuiDialogContent-root"]'}
      >
        <Paper ref={nodeRef} {...props} />
      </Draggable>
    );
  };

  // Change table sorting
  updateSorting = (by) => {
    if (by === this.state.sortBy) {
      this.setState(
        {
          sortOrder: this.state.sortOrder === "DESC" ? "ASC" : "DESC",
          page: 1,
          startRecord: 1,
        },
        () => {
          this.getProducts();
        },
      );
    } else {
      this.setState(
        {
          sortBy: by,
          sortOrder: "ASC",
          page: 1,
          startRecord: 1,
        },
        () => {
          this.getProducts();
        },
      );
    }
  };

  updateGlobalSorting = (by) => {
    if (by === this.state.globalSortBy) {
      this.setState(
        {
          globalSortOrder:
            this.state.globalSortOrder === "DESC" ? "ASC" : "DESC",
          globalPage: 1,
          globalStartRecord: 1,
        },
        () => {
          this.searchGlobalProducts();
        },
      );
    } else {
      this.setState(
        {
          globalSortBy: by,
          globalSortOrder: "ASC",
          globalPage: 1,
          globalStartRecord: 1,
        },
        () => {
          this.searchGlobalProducts();
        },
      );
    }
  };

  searchGlobalProducts = () => {
    if (this.state.globalSearchFilters.status == "all_products") {
      this.state.globalSearchFilters.status = "";
    }
    this.setState({ loading: true, viewMode: "search" });
    var customers = this.state.customersList.map((item) => {
      return item.partyId;
    });
    let pageOptions = {
      batchSize: this.state.globalPerPage,
      startRecord: this.state.globalStartRecord,
    };
    var url = `${constants.busV44UrlPublic}/products?sortBy=${this.state.globalSortBy}&sortOrder=${this.state.globalSortOrder}${customers && customers.length > 0 ? "&customer=" + customers.join() : ""}${this.state.globalSearchFilters.name ? "&name=" + this.state.globalSearchFilters.name : ""}${this.state.globalSearchFilters.code ? "&code=" + this.state.globalSearchFilters.code : ""}${this.state.globalSearchFilters.status ? "&status=" + this.state.globalSearchFilters.status : ""}`;
    if (this.state.partnerProducts) {
      url = `${constants.busV44UrlPublic}/partners/products?sortBy=${this.state.globalSortBy}&sortOrder=${this.state.globalSortOrder}${customers && customers.length > 0 ? "&customer=" + customers.join() : ""}${this.state.globalSearchFilters.name ? "&name=" + this.state.globalSearchFilters.name : ""}${this.state.globalSearchFilters.selectedPartner ? "&provider=" + this.state.globalSearchFilters.selectedPartner : ""}${this.state.globalSearchFilters.code ? "&code=" + this.state.globalSearchFilters.code : ""}${this.state.globalSearchFilters.status ? "&status=" + this.state.globalSearchFilters.status : ""}`;
    }
    BusApiCall("GET", url, {}, pageOptions)
      .then((res) => {
        // BusApiCall('GET', `${constants.busV4Url}/catalogs/products?componentType=${this.state.componentType}&mode=${this.state.isBom ? 'pmui' : 'component'}&customer=${customers.join()}`).then(res => {
        let data = res.data.map((value) => {
          value.open = false;
          return value;
        });
        this.setState({
          allGlobalProducts: data,
          globalTotalProductsCount: +res.headers["x-total-count"],
        });
        if (data) {
          this.setState(
            {
              open: false,
            },
            () => {
              this.setState({
                loading: false,
              });
            },
          );
        }
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({ loading: false });
      });
  };

  expandGlobalProduct = (id) => {
    this.setState({
      loading: true,
    });
    var components = [...this.state.allGlobalProducts];
    for (var i = 0; i < components.length; i++) {
      if (components[i].productId === id) {
        if (components[i].open) {
          components[i].open = !components[i].open;
          this.setState({
            allGlobalProducts: components,
            loading: false,
          });
        } else {
          if (components[i].bom || components[i].variants) {
            components[i].open = !components[i].open;
            this.setState({
              allGlobalProducts: components,
              loading: false,
            });
          } else {
            this.getGlobalFullProductDetails(id, i + 1);
          }
        }
      }
    }
  };

  getGlobalFullProductDetails = (id, index) => {
    var components = [...this.state.allGlobalProducts];
    var index = components.findIndex((x) => x.productId === id);
    var url = `${constants.busV44UrlPublic}/product/${id}`;
    if (this.state.partnerProducts) {
      url = `${constants.busV44UrlPublic}/partners/${components[index].providerId}/products/${id}`;
    }
    BusApiCall("GET", url)
      .then((res) => {
        var tempProductData = res.data;
        var variants = [];
        components[index].bom = tempProductData.bom;
        if (tempProductData.variants && tempProductData.variants.length > 0) {
          for (var j = 0; j < tempProductData.variants.length; j++) {
            variants.push({
              name: tempProductData.variants[j].name,
              price: tempProductData.variants[j].price,
              productId: tempProductData.variants[j].productId,
              description: tempProductData.variants[j].description,
              featureCode: tempProductData.variants[j].productCode,
              deleteId: null,
              settlementContentId: null,
              componentsProvider: null,
              componentsProviderType: null,
              inventoryItemTypeId: null,
            });
          }
        }
        components[index].variants = variants;
        components[index].open = !components[index].open;
        this.setState({
          allGlobalProducts: components,
          loading: false,
        });
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({
          loading: false,
        });
      });
  };

  changeView = (val) => {
    if (val === this.state.viewMode) {
      // Same view clicked
    } else {
      this.setState(
        {
          viewMode: val,
        },
        () => {
          if (this.state.viewMode === "search") {
            this.searchGlobalProducts();
          } else {
            this.setState({
              globalPage: 1,
              globalStartRecord: 1,
              globalSearchFilters: {
                code: "",
                name: "",
              },
              availableBuckets: [],
              butcketProducts: [],
              selectedGlobalBucket: "",
              allGlobalProducts: [],
            });
            this.getProducts();
          }
          localStorage.setItem("productViewMode", val);
        },
      );
    }
  };
  toggleChangeView = (e) => {
    if (this.state.viewMode === "search") {
      this.changeView("default");
    } else {
      this.changeView("search");
    }
  };

  showPartnerProducts = (e) => {
    this.setState(
      {
        partnerProducts: !this.state.partnerProducts,
        searchFilter: {
          name: "",
          featureCode: "",
        },
        page: 1,
        startRecord: 1,

        globalSearchFilters: {
          name: "",
          code: "",
        },
        globalPage: 1,
        globalStartRecord: 1,
        globalTotalProductsCount: 0,
      },
      () => {
        if (this.state.viewMode === "search") {
          this.searchGlobalProducts();
        } else {
          this.getProducts();
        }
      },
    );
  };

  setLeafNode = (node, index) => {
    this.clearFilters();
    const leafSubcategory = null;
    let tabName, associationTypeValue;
    if (leafSubcategory) {
      tabName = leafSubcategory.displayNamePlural
        ? leafSubcategory.displayNamePlural
        : leafSubcategory.name;
      associationTypeValue = leafSubcategory.id;
    } else {
      tabName = this.state.associationType[index].displayNamePlural
        ? this.state.associationType[index].displayNamePlural
        : this.state.associationType[index].name;
      associationTypeValue = this.state.associationType[index].id;
    }

    //set the name of the table
    this.setState(
      {
        leafNodes: [],
        tabName: tabName,
        tabValue: index,
        subTabValue: 0,
        subTabValue2: 0,
        componentType: associationTypeValue,
        page: 1,
        perPage: 10,
        startRecord: 1,
        selectAll: false,
      },
      () => {
        //call the get the existing component products API, as tab is changed
        this.getResources("ACTIVATION");
        this.getResources("PROVISIONING");
        this.getResources("SUBSCRIPTION_SUSPEND");
        this.getResources("SUBSCRIPTION_RESUME");
      },
    );
  };

  setLeafNodes = (nodes, index, subIndex) => {
    // console.log("Updating leafNodes state:", nodes, index, subIndex);
    this.clearFilters();
    const leafSubcategory = nodes.length > 0 ? nodes[0] : null;
    let tabName, associationTypeValue;
    if (leafSubcategory) {
      tabName = leafSubcategory.displayNamePlural
        ? leafSubcategory.displayNamePlural
        : leafSubcategory.name;
      associationTypeValue = leafSubcategory.id;
    } else {
      tabName = this.state.associationType[this.state.tabValue].subCategories[
        subIndex
      ].displayNamePlural
        ? this.state.associationType[this.state.tabValue].subCategories[
          subIndex
        ].displayNamePlural
        : this.state.associationType[this.state.tabValue].subCategories[
          subIndex
        ].name;
      associationTypeValue =
        this.state.associationType[this.state.tabValue].subCategories[subIndex]
          .id;
    }
    this.setState(
      {
        leafNodes: nodes,
        subTabValue: subIndex,
        tabValue: index,
        subTabValue2: 0,
        tabName: tabName,
        componentType: associationTypeValue,
        page: 1,
        perPage: 10,
        startRecord: 1,
        selectAll: false,
      },
      () => {
        this.getResources("ACTIVATION");
        this.getResources("PROVISIONING");
        this.getResources("SUBSCRIPTION_SUSPEND");
        this.getResources("SUBSCRIPTION_RESUME");
      },
    );
  };

  switchLeafNode = (event, newValue) => {
    this.clearFilters();
    const leafSubcategory =
      this.state.associationType[this.state.tabValue].subCategories[
        this.state.subTabValue
      ].subCategories[newValue];
    let tabName, associationTypeValue;
    if (leafSubcategory) {
      tabName = leafSubcategory.displayNamePlural
        ? leafSubcategory.displayNamePlural
        : leafSubcategory.name;
      associationTypeValue = leafSubcategory.id;
    } else {
      //if no 3rd level subcategory
    }

    this.setState(
      {
        subTabValue2: newValue,
        tabName: tabName,
        componentType: associationTypeValue,
        page: 1,
        perPage: 10,
        startRecord: 1,
        selectAll: false,
      },
      () => {
        this.getResources("ACTIVATION");
        this.getResources("PROVISIONING");
        this.getResources("SUBSCRIPTION_SUSPEND");
        this.getResources("SUBSCRIPTION_RESUME");
      },
    );
  };

  goToSpecification = () => {
    this.props.router.navigate("/specification");
  };
  goToCharacteristic = () => {
    this.props.router.navigate("/characteristic");
  };

  viewAssociatedOfferings = (props) => {
    var jsonData = {
      id: props.productId,
    };
    this.setState({ loading: true });
    BusApiCall(
      "POST",
      `${constants.busInternalUrl}/passthru/GET_ASSOCIATED_OFFERINGS/endpoint`,
      jsonData,
    )
      .then((res) => {
        this.setState({
          assocList: res.data.associatedList,
          showAssociatedOfferings: true,
          viewAssociatedOfferingsFor: props,
        });
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };
  closeAssociatedOfferings = () => {
    this.setState({
      showAssociatedOfferings: false,
      assocList: [],
      viewAssociatedOfferingsFor: null,
    });
  };
  assocChangePage = (event, value) => {
    this.setState({
      assocPage: value,
      assocStartRecord: this.state.assocPerPage * (value - 1) + 1,
    });
  };
  assocChangeRowsPerPage = (event) => {
    this.setState({
      assocPerPage: event.target.value,
      assocPage: 1,
      assocStartRecord: 1,
    });
  };

  render() {
    const { t } = this.props;
    const { isMobile, showCategory, showBucketsOnLeft } = this.state;
    const { classes: jssClasses } = this.props;

    const categoryList = (
      <Grid
        item
        style={{ borderRight: "1px solid lightgrey", padding: "1rem" }}
        size={{
          xs: 12,
          md: 3,
        }}
      >
        <TreeView
          data={this.state.hierarchy}
          setLeafNodes={this.setLeafNodes}
          setLeafNode={this.setLeafNode}
          mode="products"
          tenantData={this.props.tenantData}
          activeTabId={this.state.tabValue}
          subTabValue={this.state.subTabValue}
        />
      </Grid>
    );

    const componentProductTable = () => {
      return (
          <Grid item size={{ xs: 12, md: 12 }} style={{ padding: '1rem' }}>
          {this.state.leafNodes && this.state.leafNodes.length > 0 &&
              <Tabs
                  variant="scrollable"
                  style={{ marginBottom: '1rem' }}
                  scrollButtons="false"
                  indicatorColor="primary"
                  value={this.state.subTabValue2} // index of the active leaf tab
                  onChange={this.switchLeafNode}
                  className={classes.createPackageComponentTabs}
              >
                  {this.state.leafNodes.map((row, index) => (
                      <Tab key={index} label={row.name} style={{ textTransform: 'capitalize', fontSize: '1rem', fontWeight: 400 }} />
                  ))}
              </Tabs>
          }
          {/* add table */}
          <Grid container spacing={3} style={{ marginBottom: '40px' }}>

                      {this.props.providerType === 'SALES_CHNL_PROVIDER' &&
                        !this.props.tenantRoles.includes('CHILD_PROVIDER') && (
                          <Grid item size={{ xs: 12}} align="right">
                            <span>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    color="primary"
                                    checked={this.state.partnerProducts}
                                    name="partnerProducts"
                                    onChange={() => this.showPartnerProducts()}
                                  />
                                }
                                label={this.props.t('SHOW_PARTNER_PRODUCTS')}
                              />
                            </span>
                          </Grid>
                      )}

              {this.state.viewMode === 'default' && this.state.loading === false &&
                  <>
                      <Grid item size={{ xs: 12, md: 12 }} style={{ paddingTop: 0 }}>
                          {/* Table for all the components */}
                          <ComponentTable
                              //functions
                              t={t}
                              addComponent={this.openComponentDialog}
                              editComponent={this.openEditComponent}
                              removeComponent={this.openRemoveComponent}
                              exportAll={this.exportAllComponent}
                              importAll={this.verifyUploadedFile}
                              //values
                              tabValue={this.state.tabValue}
                              tableName={this.state.tabName}
                              componentType={this.state.componentType}
                              componentList={this.state.componentList}

                              page={this.state.page}
                              perPage={this.state.perPage}
                              componentListProxy={this.state.allComponentsList}
                              totalProductsCount={this.state.totalProductsCount}
                              changePage={this.changePage}
                              changeRowsPerPage={this.changeRowsPerPage}

                              updateExportSelection={this.updateExportSelection}
                              selectAllVisibleProducts={this.selectAllVisibleProducts}
                              exportSelectedItems={this.exportSelectedItems}
                              isBom={this.state.isBom}
                              importComponent={this.props.importComponent}

                              searchFilter={this.state.searchFilter}
                              updateFilter={this.updateFilter}
                              filterComponents={this.filterComponents}
                              clearFilters={this.clearFilters}
                              onSearchKeyDown={this.onSearchKeyDown}
                              productName={this.state.productName}
                              getCustomerName={this.getCustomerName}
                              customersList={this.state.customersList}

                              updateSorting={this.updateSorting}
                              sortBy={this.state.sortBy}
                              sortOrder={this.state.sortOrder}
                              viewMode={'default'}
                              expandProduct={this.expandProduct}
                              changeView={this.changeView}
                              partnerProducts={this.state.partnerProducts}
                              selectedToExport={this.state.selectedToExport}

                              selectAll={this.state.selectAll}
                              isMobile={this.state.isMobile}
                              viewAssociatedOfferings={this.viewAssociatedOfferings}
                          />
                      </Grid>
                      {/* <Grid item xs={1}></Grid> */}
                  </>
              }
          </Grid>
      </Grid>
      )
  }

    return (
      <div
        className={"newContentWrapper"}
        style={
          this.state.isBom ? { margin: "0 auto" } : { marginBottom: "0px" }
        }
      >
        {this.state.isBom ? (
          ""
        ) : (
          <div className={"breadcrumbWrapper"}>
            <div className={"breadcrumbContent"}>
              <Grid container>
                <Grid
                  item
                  size={{
                    xs: 4,
                    md: 4,
                  }}
                >
                  <Breadcrumb list={this.state.bread} />
                </Grid>

                <Grid
                  item
                  align="right"
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    gap: "1rem",
                  }}
                  size={{
                    xs: 8,
                    md: 8,
                  }}
                >
                  <div>
                    {this.props.providerType === "SALES_CHNL_PROVIDER" &&
                      !this.state.partnerProducts && (
                        <h3 style={{ margin: 0, fontWeight: "normal" }}>
                          {t("SHOW_FOR_CUSTOMER")}:&nbsp;
                          <span
                            style={{
                              fontWeight: "bold",
                              color: this.props.tenantData.color,
                              cursor: "pointer",
                            }}
                            onClick={() => this.changeCustomer()}
                          >
                            {this.state.customersList &&
                              this.state.customersList.length > 0 ? (
                              <>
                                {this.state.customersList[0].accountName}
                                {this.state.customersList.length > 1 && (
                                  <Tooltip
                                    title={
                                      <React.Fragment
                                        style={{ whiteSpace: "pre" }}
                                      >
                                        {this.state.customersList.map(
                                          (item, index) =>
                                            index > 0 && (
                                              <div>{item.accountName}</div>
                                            ),
                                        )}
                                      </React.Fragment>
                                    }
                                  >
                                    <span>&nbsp;...</span>
                                  </Tooltip>
                                )}
                              </>
                            ) : (
                              this.props.t("ALL")
                            )}
                            <Tooltip title={t("CHANGE")}>
                              <span
                                style={{
                                  fontSize: "20px",
                                  marginLeft: ".5rem",
                                  verticalAlign: "middle",
                                }}
                              >
                                <EditIconNew
                                  style={{
                                    position: "absolute",
                                    fontSize: "20px",
                                    marginLeft: "5px",
                                  }}
                                />
                              </span>
                            </Tooltip>
                          </span>
                          {this.state.customersList &&
                            this.state.customersList.length > 0 && (
                              <span
                                style={{
                                  cursor: "pointer",
                                  position: "relative",
                                  top: ".4rem",
                                  color: this.props.tenantData.color,
                                }}
                              >
                                <Tooltip title={this.props.t("CLEAR")}>
                                  <ClearIconMUI
                                    onClick={() =>
                                      this.clearCustomerSelection()
                                    }
                                  />
                                </Tooltip>
                              </span>
                            )}
                        </h3>
                      )}
                  </div>

                  {this.props.menuPaths.includes("/specification") && (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center",
                        gap: ".5rem",
                      }}
                    >
                      <Button
                        className="buttonPrimary"
                        onClick={this.goToSpecification}
                      >
                        {t("PRODUCT_SPECIFICATIONS")}
                      </Button>
                      <Button
                        className="buttonPrimary"
                        onClick={this.goToCharacteristic}
                      >
                        {t("PRODUCT_CHARACTERISTICS")}
                      </Button>
                    </div>
                  )}
                </Grid>

                {isMobile && (
                  <Grid
                    item
                    style={{
                      marginTop: "1rem",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                    size={{
                      xs: 12,
                    }}
                  >
                    {this.state.viewMode !== "search" && (
                      <>
                        <div>
                          {this.state.hierarchy?.[this.state.tabValue]
                            ?.subCategories &&
                            this.state.hierarchy?.[this.state.tabValue]?.name}
                          {this.state.subTabValue !== null &&
                            this.state.subTabValue !== undefined &&
                            this.state.hierarchy?.[this.state.tabValue]
                              ?.subCategories && (
                              <>
                                {" >"}{" "}
                                {
                                  this.state.hierarchy[this.state.tabValue]
                                    ?.subCategories[this.state.subTabValue]
                                    ?.name
                                }
                              </>
                            )}
                        </div>
                        <Button
                          className="buttonSecondary"
                          onClick={this.toggleShowCategory}
                        >
                          <span
                            style={{
                              marginRight: ".25rem",
                              verticalAlign: "middle",
                            }}
                          >
                            <MenuIcon />
                          </span>
                          {t("SHOW_PRODUCT_CATEGORY")}
                        </Button>
                      </>
                    )}
                  </Grid>
                )}
              </Grid>
            </div>
          </div>
        )}
        <main
          style={
            this.state.isBom
              ? { margin: 0, padding: 0 }
              : { marginBottom: "0px" }
          }
        >
          <Grid container spacing={2} style={{ marginBottom: ".5rem" }}>
            <Grid
              item
              style={{ justifyContent: "flex-end", display: "flex" }}
              size={{
                xs: 12,
                md: 12,
              }}
            >
              <ButtonGroup variant="outlined">
                {/* DETAIL VIEW button */}
                <span
                  className={`buttonGroup ${this.state.viewMode !== "search" ? "selected" : ""}`}
                  onClick={(e) => this.toggleChangeView(e)}
                  style={{
                    backgroundColor:
                      this.state.viewMode !== "search"
                        ? this.props.tenantData.color
                        : "inherit",
                    color:
                      this.state.viewMode !== "search" ? "white" : "inherit",
                  }}
                >
                  <span style={{ marginRight: ".4rem" }}>
                    {this.props.t("CATEGORY_VIEW")}
                  </span>
                  <DetailView />
                </span>
                {/* LIST VIEW button */}
                <span
                  className={`buttonGroup ${this.state.viewMode === "search" ? "selected" : ""}`}
                  onClick={(e) => this.toggleChangeView(e)}
                  style={{
                    backgroundColor:
                      this.state.viewMode === "search"
                        ? this.props.tenantData.color
                        : "inherit",
                    color:
                      this.state.viewMode === "search" ? "white" : "inherit",
                  }}
                >
                  <span>{this.props.t("LIST_VIEW")}</span>
                  <ListView />
                </span>
              </ButtonGroup>
            </Grid>
          </Grid>
          <div
            style={{
              borderRadius: "8px",
              border: "1px solid lightgrey",
              background: "white",
              marginBottom: "40px",
            }}
          >
            {!this.state.noComponentTypes && (
              <div>
                {this.state.viewMode === "default" && (
                  <>
                    <div>
                      <Grid container spacing={0}>
                        {!isMobile ? (
                          !showBucketsOnLeft ? (
                            // buckets as tabs horizontally
                            <Grid
                              container
                              spacing={1}
                              style={{ marginTop: "1rem" }}
                            >
                              <Grid
                                item
                                size={{
                                  xs: 12,
                                }}
                              >
                                <Box
                                  display="flex"
                                  justifyContent="center"
                                  width="100%"
                                >
                                  <Tabs
                                    // textColor="primary"
                                    variant="scrollable"
                                    scrollButtons="auto"
                                    // indicatorColor="primary"
                                    value={this.state.tabValue}
                                    onChange={this.handleChange}
                                    className={
                                      classes.createPackageComponentTabs
                                    }
                                  >
                                    {(this.state.associationType &&
                                      this.state.associationType.length) > 0
                                      ? this.state.associationType.map(
                                        (row, index) =>
                                          row.id != "PROD_COMP_REF_PKG" && (
                                            <Tab
                                              key={index}
                                              label={
                                                row.displayNamePlural
                                                  ? row.auxiliary
                                                    ? row.displayNamePlural
                                                    : row.displayNamePlural
                                                  : row.auxiliary
                                                    ? row.name
                                                    : row.name
                                              }
                                            />
                                          ),
                                      )
                                      : null}
                                  </Tabs>
                                </Box>
                              </Grid>
                              {this.state.associationType[
                                this.state.tabValue
                              ] &&
                                this.state.associationType[this.state.tabValue]
                                  .subCategories && (
                                  <Grid
                                    item
                                    size={{
                                      xs: 12,
                                    }}
                                  >
                                    <Box
                                      display="flex"
                                      justifyContent="left"
                                      width="100%"
                                    >
                                      <Tabs
                                        // textColor="primary"
                                        variant="scrollable"
                                        scrollButtons="auto"
                                        // indicatorColor="primary"
                                        value={this.state.subTabValue}
                                        onChange={this.handleSubChange}
                                        className={
                                          classes.createPackageComponentTabs
                                        }
                                      >
                                        {this.state.associationType[
                                          this.state.tabValue
                                        ].subCategories &&
                                          this.state.associationType[
                                            this.state.tabValue
                                          ].subCategories.length > 0
                                          ? this.state.associationType[
                                            this.state.tabValue
                                          ].subCategories.map(
                                            (row, index) => (
                                              <Tab
                                                key={index}
                                                label={row.name}
                                              />
                                            ),
                                          )
                                          : null}
                                      </Tabs>
                                    </Box>
                                  </Grid>
                                )}
                              {this.state.associationType[
                                this.state.tabValue
                              ] &&
                                this.state.associationType[this.state.tabValue]
                                  .subCategories &&
                                this.state.associationType[this.state.tabValue]
                                  .subCategories[this.state.subTabValue]
                                  .subCategories && (
                                  <Grid
                                    item
                                    size={{
                                      xs: 12,
                                    }}
                                  >
                                    <Box
                                      display="flex"
                                      justifyContent="left"
                                      width="100%"
                                    >
                                      <Tabs
                                        // textColor="primary"
                                        variant="scrollable"
                                        scrollButtons="auto"
                                        // indicatorColor="primary"
                                        value={this.state.subTabValue2}
                                        onChange={this.handleSub2Change}
                                        className={
                                          classes.createPackageComponentTabs
                                        }
                                      >
                                        {this.state.associationType[
                                          this.state.tabValue
                                        ].subCategories &&
                                          this.state.associationType[
                                            this.state.tabValue
                                          ].subCategories.length > 0
                                          ? this.state.associationType[
                                            this.state.tabValue
                                          ].subCategories[
                                            this.state.subTabValue
                                          ].subCategories &&
                                            this.state.associationType[
                                              this.state.tabValue
                                            ].subCategories[
                                              this.state.subTabValue
                                            ].subCategories.length > 0
                                            ? this.state.associationType[
                                              this.state.tabValue
                                            ].subCategories[
                                              this.state.subTabValue
                                            ].subCategories.map(
                                              (row, index) => (
                                                <Tab
                                                  key={index}
                                                  label={row.name}
                                                />
                                              ),
                                            )
                                            : null
                                          : null}
                                      </Tabs>
                                    </Box>
                                  </Grid>
                                )}
                              <Box
                                className={classes.tabUnderLine}
                                style={{
                                  display: "flex",
                                  marginTop: "2rem",
                                  justifyContent: "center",
                                  width: "100%",
                                }}
                              ></Box>
                            </Grid>
                            //horizontal tabs end
                          ) : (
                            <Split
                            sizes={[20, 80]} // Initial sizes in percentages
                            minSize={[200, 600]} // Minimum sizes in pixels
                            expandToMin={false}
                            gutterSize={10}
                            gutterAlign="center"
                            snapOffset={30}
                            dragInterval={1}
                            direction="horizontal"
                            cursor="col-resize"
                            className='split'
                        >
                            {/* left */}
                            <div style={{ overflow: 'auto', borderRight: '1px solid lightgrey' }}>
                            <Grid
                              item
                              style={{
                                borderRight: "1px solid lightgrey",
                                padding: "1rem",
                              }}
                              size={{
                                xs: 12,
                                md: 12,
                              }}
                            >
                              <TreeView
                                data={this.state.hierarchy}
                                setLeafNodes={this.setLeafNodes}
                                setLeafNode={this.setLeafNode}
                                mode="products"
                                tenantData={this.props.tenantData}
                                activeTabId={this.state.tabValue}
                                subTabValue={this.state.subTabValue}
                              />
                            </Grid>
                            </div>
                            {/* right */}
                            <div style={{ overflow: 'auto' }}>
                                 {componentProductTable()}
                               </div>
                            </Split>
                          )
                        ) : (
                          isMobile &&
                          showCategory && (
                            <Drawer
                              anchor="left"
                              // variant='permanant'
                              open={showCategory}
                              onClose={() => {
                                this.toggleShowCategory();
                              }}
                              // classes={{ paper: classes.drawerPaper }}
                              PaperProps={{
                                style: {
                                  width: "100%",
                                  maxWidth: "100vw",
                                },
                              }}
                            >
                              <div>
                                <div>
                                  <IconButton
                                    onClick={() => {
                                      this.toggleShowCategory();
                                    }}
                                  >
                                    <ChevronLeft />
                                  </IconButton>
                                </div>
                                <Card
                                  variant="outlined"
                                  className={"roundedCorners"}
                                >
                                  {categoryList}
                                </Card>
                              </div>
                            </Drawer>
                          )
                        )}
                      {(isMobile && !showCategory) && componentProductTable()}
                      </Grid>
                    </div>
                    {/* <Grid container spacing={3}>
                                    
                                    <Grid item xs={12}>
                                        <Box display="flex" justifyContent="center" width="100%">
                                            <Tabs
                                                // textColor="primary"
                                                variant="scrollable"
                                                scrollButtons="auto"
                                                indicatorColor="primary"
                                                value={this.state.tabValue}
                                                onChange={this.handleChange}
                                                className={classes.createPackageComponentTabs}
                                            >
                                                {(this.state.associationType && this.state.associationType.length) > 0
                                                    ?
                                                    this.state.associationType.map((row, index) => (
                                                        row.id != "PROD_COMP_REF_PKG" &&
                                                        <Tab key={index}
                                                            label=
                                                            {
                                                                row.displayNamePlural
                                                                    ?
                                                                    row.auxiliary ? row.displayNamePlural : row.displayNamePlural
                                                                    :
                                                                    row.auxiliary ? row.name : row.name
                                                            }
                                                        />
                                                    ))
                                                    :
                                                    null
                                                }
                                            </Tabs>
                                        </Box>
                                    </Grid>
                                    {this.state.associationType[this.state.tabValue] && this.state.associationType[this.state.tabValue].subCategories &&
                                        <Grid item xs={12}>
                                            <Box display="flex" justifyContent="left" width="100%">
                                                <Tabs
                                                    // textColor="primary"
                                                    variant="scrollable"
                                                    scrollButtons="auto"
                                                    indicatorColor="primary"
                                                    value={this.state.subTabValue}
                                                    onChange={this.handleSubChange}
                                                    className={classes.createPackageComponentTabs}
                                                >
                                                    {(this.state.associationType[this.state.tabValue].subCategories && this.state.associationType[this.state.tabValue].subCategories.length > 0)
                                                        ?
                                                        this.state.associationType[this.state.tabValue].subCategories.map((row, index) => (
                                                            <Tab
                                                                key={index}
                                                                label={row.name}
                                                            />
                                                        ))
                                                        :
                                                        null
                                                    }
                                                </Tabs>
                                            </Box>
                                        </Grid>
                                    }

                                    {this.state.associationType[this.state.tabValue] && this.state.associationType[this.state.tabValue].subCategories &&
                                        this.state.associationType[this.state.tabValue].subCategories[this.state.subTabValue].subCategories &&
                                        <Grid item xs={12}>
                                            <Box display="flex" justifyContent="left" width="100%">
                                                <Tabs
                                                    // textColor="primary"
                                                    variant="scrollable"
                                                    scrollButtons="auto"
                                                    indicatorColor="primary"
                                                    value={this.state.subTabValue2}
                                                    onChange={this.handleSub2Change}
                                                    className={classes.createPackageComponentTabs}
                                                >
                                                    {(this.state.associationType[this.state.tabValue].subCategories &&
                                                        this.state.associationType[this.state.tabValue].subCategories.length > 0)
                                                        ?
                                                        (this.state.associationType[this.state.tabValue].subCategories[this.state.subTabValue].subCategories &&
                                                            this.state.associationType[this.state.tabValue].subCategories[this.state.subTabValue].subCategories.length > 0) ?
                                                            this.state.associationType[this.state.tabValue].subCategories[this.state.subTabValue].subCategories.map((row, index) => (
                                                                <Tab
                                                                    key={index}
                                                                    label={row.name}
                                                                />
                                                            ))
                                                            : null
                                                        : null
                                                    }
                                                </Tabs>
                                            </Box>
                                        </Grid>
                                    }
                                </Grid> */}
                  </>
                )}

                {/* {this.state.loading === false && */}
                {/* {this.state.viewMode === 'search' && this.state.loading === false &&
                                <Grid container spacing={3} style={{marginBottom: '40px'}}>
                                    <Grid item xs={12} align="right" >
                                        <span>
                                            {this.props.providerType === 'SALES_CHNL_PROVIDER' &&
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox color="primary" checked={this.state.partnerProducts} name="partnerProducts" onChange={(e) => this.showPartnerProducts()} />
                                                    }
                                                    label={this.props.t('PARTNER_PRODUCTS')}
                                                />
                                            }
                                        </span>
                                        <span style={{ marginLeft: '12px' }}>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox color="primary" checked={this.state.partnerProducts} name="partnerProducts" onChange={(e) => this.showPartnerProducts()} />
                                                }
                                                label={this.props.t('PARTNER_PRODUCTS')}
                                            />
                                        </span>
                                    </Grid>
                                    </Grid>
                            } */}
                {/* <Grid item xs={1}></Grid> */}

                {/* <Grid item xs={1}></Grid>
                                <Grid item xs={10}>
                                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                        <div className={classes.searchOuterDiv}>
                                            <div className={classes.searchInputDiv}>
                                                <Input
                                                    name="name"
                                                    value={this.state.globalSearchFilters.name}
                                                    placeholder={t('SEARCH_IN_CATEGORIES_BY_NAME')}
                                                    onChange={this.globalSearchChange}
                                                    onKeyDown={this.onSearchKeyDown}
                                                    style={{ width: '300px' }}
                                                />
                                            </div>
                                            <div className={classes.searchInputDiv}>
                                                <Input
                                                    name="code"
                                                    value={this.state.globalSearchFilters.code}
                                                    placeholder={t('SEARCH_IN_CATEGORIES_BY_CODE')}
                                                    onChange={this.globalSearchChange}
                                                    onKeyDown={this.onSearchKeyDown}
                                                    style={{ width: '300px' }}
                                                />
                                            </div>
                                            <div className={classes.searchOrderLabelOuter}>
                                                <div className={classes.searchOrderLabelInner}>
                                                    <Tooltip title={t('SEARCH')}>
                                                        <IconButton onClick={this.globalFilterComponents}>
                                                            <SearchIcon />
                                                        </IconButton>
                                                    </Tooltip> &nbsp;
                                                    <Tooltip title={t('CLEAR')}>
                                                        <IconButton onClick={this.globalSearchClear}>
                                                            <ClearIcon />
                                                        </IconButton>
                                                    </Tooltip>
                                                </div>
                                            </div>
                                            <div className='cl'></div>
                                        </div>
                                        <Tooltip title={t('CATEGORY_VIEW')}>
                                            <ViewModuleIcon style={{
                                                color: this.state.viewMode === 'default' ? this.props.tenantData.color : 'grey'
                                            }} fontSize='large' onClick={() => this.changeView('default')} />
                                        </Tooltip>

                                        <Tooltip title={t('TABLE_VIEW')}>
                                            <DehazeIcon style={{
                                                color: this.state.viewMode === 'search' ? this.props.tenantData.color : 'grey'
                                            }} fontSize='large' onClick={() => this.changeView('search')} />
                                        </Tooltip>
                                    </div>
                                </Grid>
                                <Grid item xs={1}></Grid> */}
                {/* {this.state.viewMode === 'default' && this.state.loading === false &&
                                        <>
                                            <Grid item xs={12} style={{ paddingTop: 0 }}>
                                                
                                                <ComponentTable
                                                    //functions
                                                    t={t}
                                                    addComponent={this.openComponentDialog}
                                                    editComponent={this.openEditComponent}
                                                    removeComponent={this.openRemoveComponent}
                                                    exportAll={this.exportAllComponent}
                                                    importAll={this.verifyUploadedFile}
                                                    //values
                                                    tabValue={this.state.tabValue}
                                                    tableName={this.state.tabName}
                                                    componentType={this.state.componentType}
                                                    componentList={this.state.componentList}

                                                page={this.state.page}
                                                perPage={this.state.perPage}
                                                componentListProxy={this.state.allComponentsList}
                                                totalProductsCount={this.state.totalProductsCount}
                                                changePage={this.changePage}
                                                changeRowsPerPage={this.changeRowsPerPage}

                                                updateExportSelection={this.updateExportSelection}
                                                selectAllVisibleProducts={this.selectAllVisibleProducts}
                                                exportSelectedItems={this.exportSelectedItems}
                                                isBom={this.state.isBom}
                                                importComponent={this.props.importComponent}

                                                searchFilter={this.state.searchFilter}
                                                updateFilter={this.updateFilter}
                                                filterComponents={this.filterComponents}
                                                clearFilters={this.clearFilters}
                                                onSearchKeyDown={this.onSearchKeyDown}
                                                productName={this.state.productName}
                                                getCustomerName={this.getCustomerName}
                                                customersList={this.state.customersList}

                                                updateSorting={this.updateSorting}
                                                sortBy={this.state.sortBy}
                                                sortOrder={this.state.sortOrder}
                                                viewMode={'default'}
                                                expandProduct={this.expandProduct}
                                                changeView={this.changeView}
                                                partnerProducts={this.state.partnerProducts}
                                                selectedToExport={this.state.selectedToExport}

                                                    selectAll={this.state.selectAll}
                                                />
                                            </Grid>
                                            
                                        </>
                                    } */}
                {/* </Grid> */}
                {/* } */}
              </div>
            )}
            {this.state.viewMode === "search" &&
              this.state.loading === false && (
                <div style={{ padding: "1rem" }}>
                  <Grid container spacing={1}>
                    <Grid
                      item
                      align="right"
                      size={{
                        xs: 12,
                      }}
                    >
                      <span>
                        {
                          this.props.providerType === "SALES_CHNL_PROVIDER" &&
                          !this.props.tenantRoles.includes(
                            "CHILD_PROVIDER",
                          ) && (
                            <FormControlLabel
                              control={
                                <Checkbox
                                  color="primary"
                                  checked={this.state.partnerProducts}
                                  name="partnerProducts"
                                  onChange={(e) => this.showPartnerProducts()}
                                />
                              }
                              label={this.props.t("SHOW_PARTNER_PRODUCTS")}
                            />
                          )
                          // <FormControlLabel
                          //     control={
                          //         <Switch
                          //             color="primary"
                          //             checked={this.state.partnerProducts}
                          //             name="partnerProducts"
                          //             onChange={(e) => this.showPartnerProducts()}
                          //         />
                          //     }
                          //     label={this.props.t('PARTNER_PRODUCTS')}
                          // />
                        }
                      </span>
                      {/* <span style={{ marginLeft: '12px' }}>
                                            <FormControlLabel
                                                control={
                                                    <Switch
                                                        color="primary"
                                                        checked={this.state.viewMode === 'search'}
                                                        name="showAllProducts"
                                                        onChange={(e) => this.toggleChangeView(e)}
                                                    />
                                                }
                                                label={this.props.t('SHOW_ALL_PRODUCTS')}
                                            />

                                        </span> */}
                    </Grid>
                  </Grid>
                  <Grid container spacing={3} style={{ marginBottom: "20px" }}>
                    <Grid
                      item
                      size={{
                        xs: 12,
                      }}
                    >
                      <ComponentTable
                        //functions
                        t={t}
                        addComponent={this.openComponentDialog}
                        editComponent={this.openGlobalEditComponent}
                        removeComponent={this.openRemoveComponent}
                        exportAll={this.exportAllComponent}
                        importAll={this.verifyUploadedFile}
                        //values
                        tabValue={this.state.tabValue}
                        tableName={this.state.tabName}
                        componentType={this.state.componentType}
                        componentList={this.state.allGlobalProducts}
                        page={this.state.globalPage}
                        perPage={this.state.globalPerPage}
                        componentListProxy={this.state.allGlobalProducts}
                        totalProductsCount={this.state.globalTotalProductsCount}
                        changePage={this.globalChangePage}
                        changeRowsPerPage={this.globalChangeRowsPerPage}
                        updateExportSelection={this.updateExportSelection}
                        selectAllVisibleProducts={this.selectAllVisibleProducts}
                        exportSelectedItems={this.exportSelectedItems}
                        isBom={this.state.isBom}
                        importComponent={this.props.importComponent}
                        searchFilter={this.state.globalSearchFilters}
                        updateFilter={this.globalSearchChange}
                        filterComponents={this.globalFilterComponents}
                        clearFilters={this.globalSearchClear}
                        onSearchKeyDown={this.onSearchKeyDown}
                        productName={this.state.productName}
                        getCustomerName={this.getCustomerName}
                        customersList={this.state.customersList}
                        updateSorting={this.updateGlobalSorting}
                        sortBy={this.state.globalSortBy}
                        sortOrder={this.state.globalSortOrder}
                        viewMode={"search"}
                        expandProduct={this.expandGlobalProduct}
                        changeView={this.changeView}
                        partnerProducts={this.state.partnerProducts}
                        selectedToExport={this.state.selectedToExport}
                        modules={this.state.modules}
                        selectAll={this.state.selectAll}
                        isMobile={this.state.isMobile}
                        viewAssociatedOfferings={this.viewAssociatedOfferings}
                        partnerList={this.state.partnerList}
                      />
                    </Grid>
                  </Grid>
                </div>
              )}

            {/* Add/Edit Component Dialog */}
            {this.state.showAddComponent && (
              <ComponentDialog
                open={this.state.showAddComponent}
                mode={this.state.mode}
                componentType={
                  this.state.viewMode === "search"
                    ? this.state.globalComponentType
                    : this.state.componentType
                }
                closeDialog={this.closeComponentDialog}
                tabName={this.state.tabName}
                provisioningResources={
                  this.state.viewMode === "search"
                    ? this.state.globalProvisioningResourceList
                    : this.state.provisioningResourceList
                }
                activationResources={
                  this.state.viewMode === "search"
                    ? this.state.globalActivationResourceList
                    : this.state.activationResourceList
                }
                suspendResources={
                  this.state.viewMode === "search"
                    ? this.state.globalSuspendResourceList
                    : this.state.suspendResourceList
                }
                resumeResources={
                  this.state.viewMode === "search"
                    ? this.state.globalResumeResourceList
                    : this.state.resumeResourceList
                }
                editData={this.state.objectToEdit}
                addComponentType={this.state.addComponentType}
                preQualResourcesList={this.state.preQualResourcesList}
                productErrorMessage={this.state.productErrorMessage}
                // sellable product
                categoryList={this.state.categoryList}
                originalBucketsData={this.state.allCategoriesList}
                channelList={this.state.channelList}
                specCategoryList={this.state.specCategoryList}
                productSpecificationsCount={
                  this.state.productSpecificationsCount
                }
                resetErrorMessage={this.resetErrorMessage}
                providerType={this.props.providerType}
                readonlyMode={
                  (this.state.partnerProducts ? true : false) ||
                  this.state.objectToEdit.status === "P_PUBLISHED"
                }
                priceOptions={this.state.priceOptions}
                disableOtherPriceOption={this.disableOtherPriceOption}
                modules={this.state.modules}
                allOtherPricesList={this.state.allOtherPricesList}
                status={this.state.status}
                isMobile={this.state.isMobile}
              />
            )}

            {/* Associated Offerings dialog */}
            <Dialog
              maxWidth={"sm"}
              fullWidth={true}
              open={this.state.showAssociatedOfferings}
              aria-labelledby="associated-offerings-dialog"
              // PaperComponent={this.associatedOfferingsDialog}
              PaperComponent={DraggableResizablePaper}
            // PaperProps={{
            //     className: jssClasses.resizablePaper
            // }}
            >
              <DialogTitle
                id="associated-offerings-dialog"
                style={{ cursor: "move" }}
              >
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  {`${t("ASSOCIATED_OFFERINGS")}: ${this.state.viewAssociatedOfferingsFor?.name || ""}`}
                  <Tooltip title={t("CLOSE")}>
                    <IconButton
                      onClick={(event) => this.closeAssociatedOfferings()}
                      aria-label="close"
                    >
                      <CloseIcon />
                    </IconButton>
                  </Tooltip>
                </div>
              </DialogTitle>
              <DialogContent dividers>
                {this.state.assocList && this.state.assocList.length > 0 ? (
                  <Card
                    variant="outlined"
                    className="roundCorners borderOutline"
                    style={{ padding: "0" }}
                  >
                    <TableContainer>
                      <Table className="newGlobalTable">
                        <TableHead>
                          <TableRow>
                            <TableCell>{t("OFFERING_CODE")}</TableCell>
                            <TableCell>{t("OFFERING_NAME")}</TableCell>
                            <TableCell>{t("STATUS")}</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {this.state.assocList &&
                            this.state.assocList.length > 0 &&
                            this.state.assocList.map((row, index) => (
                              <TableRow key={index}>
                                <TableCell>{row.code}</TableCell>
                                <TableCell>{row.name}</TableCell>
                                <TableCell>
                                  <Chip
                                    label={t(row.state)}
                                    className={
                                      row.state === "P_IN_DRAFT"
                                        ? "inProgressChip"
                                        : row.state === "P_PUBLISHED"
                                          ? "successChip"
                                          : row.state === "P_RETIRED" ||
                                            row.state === "P_EXPIRED" ||
                                            row.state === "P_OBSOLETE" ||
                                            row.state === "P_REJECTED"
                                            ? "errorChip"
                                            : "defaultChip"
                                    }
                                  />
                                </TableCell>
                              </TableRow>
                            ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                    {this.state.assocList &&
                      this.state.assocList.length > 0 && (
                        <div
                          className="global-custom-pagination"
                          style={{ background: "rgba(196, 196, 196, 0.2)" }}
                        >
                          <label style={{ float: "left", padding: "5px" }}>
                            {t("TOTAL_RECORDS")}: {formatNumber(this.state.assocList.length)}
                          </label>
                          <label>
                            {/* Rows per page select */}
                            {t("ROWS_PER_PAGE")}
                            <Select
                              value={this.state.assocPerPage}
                              onChange={this.assocChangeRowsPerPage}
                            >
                              <MenuItem
                                value={10}
                                classes={{ root: "treeRowPerPageItem" }}
                              >
                                10
                              </MenuItem>
                              <MenuItem
                                value={50}
                                classes={{ root: "treeRowPerPageItem" }}
                              >
                                50
                              </MenuItem>
                              <MenuItem
                                value={100}
                                classes={{ root: "treeRowPerPageItem" }}
                              >
                                100
                              </MenuItem>
                            </Select>
                          </label>
                          {/* Pagination component */}
                          <Pagination
                            page={this.state.assocPage}
                            count={Math.ceil(
                              this.state.assocList.length /
                              this.state.assocPerPage,
                            )}
                            onChange={this.assocChangePage}
                            showFirstButton
                            showLastButton
                          />
                        </div>
                      )}
                  </Card>
                ) : (
                  <DialogContentText>
                    {t("NO_ASSOCIATED_OFFERINGS")}
                  </DialogContentText>
                )}
              </DialogContent>
              <DialogActions>
                <Button
                  className="buttonSecondary"
                  onClick={(event) => this.closeAssociatedOfferings()}
                  color="primary"
                >
                  {t("CLOSE")}
                </Button>
              </DialogActions>
            </Dialog>

            {/* Delete Component dialog */}
            <Dialog
              maxWidth={"sm"}
              fullWidth={true}
              open={this.state.showDelete}
              aria-labelledby="delete-dialog"
              PaperComponent={this.deleteDialog}
              disableScrollLock={true}
            // PaperProps={{
            //     className: jssClasses.resizablePaper
            // }}
            >
              <DialogTitle id="delete-dialog" style={{ cursor: "move" }}>
                {t("DELETE")}{" "}
                {this.state.viewMode === "search" ? "" : this.state.tabName}
              </DialogTitle>
              <DialogContent dividers>
                <DialogContentText>
                  {t("REMOVE_COMPONENT_MESSAGE")}
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={(event) => this.closeDeleteCoponentDialog(false)}
                  color="primary"
                >
                  {t("CANCEL")}
                </Button>
                <Button
                  onClick={(event) => this.closeDeleteCoponentDialog(true)}
                  color="primary"
                >
                  {t("YES")}
                </Button>
              </DialogActions>
            </Dialog>

            <Dialog
              disableScrollLock={true}
              maxWidth={"sm"}
              fullWidth={true}
              open={this.state.showImportDialog}
              aria-labelledby="import-dialog"
              PaperComponent={this.importDialog}
            // PaperProps={{
            //     className: jssClasses.resizablePaper
            // }}
            >
              <DialogTitle id="import-dialog" style={{ cursor: "move" }}>
                {t("CONFIRM_IMPORT")}
              </DialogTitle>
              <DialogContent dividers>
                <DialogContentText>
                  {this.state.duplicateExists && (
                    <>
                      {/* Below {this.state.existedProd.length > 1 ? 'products' : 'product'} already exists. Please change the name or you can choose skip option? */}
                      {t("COMPONENT_ALREADY_EXIST")}
                      {this.state.existedProd.map((row, index) => (
                        <div>
                          <b>{row}</b>
                        </div>
                      ))}
                    </>
                  )}

                  {this.state.bucketMismatched && (
                    <>{t("BUCKET_MISMATCH_MESSAGE")}</>
                  )}
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                {this.state.duplicateExists && (
                  <>
                    <Button
                      onClick={(event) => this.closeImportVarifyDialog(false)}
                      color="primary"
                    >
                      {t("CANCEL")}
                    </Button>
                    <Button
                      onClick={(event) => this.closeImportVarifyDialog(true)}
                      color="primary"
                    >
                      {t("Skip")}
                    </Button>
                  </>
                )}
                {this.state.bucketMismatched && (
                  <>
                    <Button
                      onClick={(event) => this.closeImportDialog(false)}
                      color="primary"
                    >
                      {t("CANCEL")}
                    </Button>
                    <Button
                      onClick={(event) => this.closeImportDialog(true)}
                      color="primary"
                    >
                      {t("Ok")}
                    </Button>
                  </>
                )}
              </DialogActions>
            </Dialog>
            {this.state.showCustomerDialog && (
              <Dialog
                disableScrollLock={true}
                // maxWidth={"sm"}
                // fullWidth={true}
                open={this.state.showCustomerDialog}
                aria-labelledby="select-customer-dialog"
                // PaperComponent={this.selectCustomerDialog}
                PaperComponent={DraggableResizablePaper}
                PaperProps={{
                  sx: {
                    width: { xs: '92vw', sm: 720 },   // 92vw on mobile, 720px on >=sm
                    minHeight: 300,
                    maxHeight: '80vh'
                  }
                }}
              >
                <DialogTitle
                  id="select-customer-dialog"
                  style={{ cursor: "move" }}
                >
                  <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <span style={{ display: "inline-flex" }}>
                      {this.props.loggedInUserType === "ECOMMERCE_CUSTOMER" ||
                        this.props.loggedInUserType === "ECOMMERCE_ADMIN"
                        ? t("SELECT_SHIPPING_ADDRESS")
                        : t("SELECT_CUSTOMER")}
                    </span>
                    <Tooltip title={t("CLOSE")}>
                      <IconButton
                        onTouchStart={(event) =>
                          this.closeChangeCustomer(false)
                        }
                        onClick={(event) => this.closeChangeCustomer(false)}
                        aria-label="close"
                      >
                        <CloseIcon />
                      </IconButton>
                    </Tooltip>
                  </div>
                </DialogTitle>
                <DialogContent dividers style={{ height: "550px" }}>
                  <ManageCustomersHierarchy
                    screen="products"
                    subScreen="productsFilter"
                    selectCustomers={this.selectCustomers}
                    customerData={this.state.proxyCustomersList}
                  />
                </DialogContent>
                <DialogActions>
                  {/* <Button onClick={event => this.closeChangeCustomer(false)} color="primary">{t('CANCEL')}</Button> */}
                  {/* <Button onClick={event => this.closeChangeCustomer(true)} color="primary">{t('SAVE')}</Button> */}
                  <Button
                    onClick={(event) => this.closeChangeCustomer(true)}
                    color="primary"
                  >
                    {t("SHOW_PRODUCTS")}
                  </Button>
                </DialogActions>
              </Dialog>
            )}

            <Loader loading={this.state.loading} />
            <Loader loading={this.state.partialLoading} />
          </div>
        </main>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    providerId: state.auth.tenantId,
    providerType: state.auth.providerType,
    enabledModules: state.auth.enabledModules,
    permissions: state.auth.userPerms,
    tenantData: state.auth.tenantData,
    loggedInUserType: state.auth.userLoginType,
    tenantRoles: state.auth.tenantRoles,
    menuPaths: state.auth.menuPaths,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(withNavigation(ComponentProduct)));
